/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AdminRouteRouteImport } from './routes/admin/route'
import { Route as AppRouteRouteImport } from './routes/app/route'
import { Route as BrandRouteImport } from './routes/brand'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as PortalRouteRouteImport } from './routes/portal/route'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth/forgot-password'
import { Route as AuthLoginRouteImport } from './routes/_auth/login'
import { Route as AuthMfaRouteImport } from './routes/_auth/mfa'
import { Route as AuthRegisterRouteImport } from './routes/_auth/register'
import { Route as AuthSelectClientRouteImport } from './routes/_auth/select-client'
import { Route as AuthSelectContractRouteImport } from './routes/_auth/select-contract'
import { Route as AuthUnsubscribedRouteImport } from './routes/_auth/unsubscribed'
import { Route as AdminIndexRouteImport } from './routes/admin/index'
import { Route as AdminAccountsRouteImport } from './routes/admin/accounts'
import { Route as AdminAdminAuditRouteImport } from './routes/admin/admin-audit'
import { Route as AdminAuditRouteImport } from './routes/admin/audit'
import { Route as AdminEmailRouteImport } from './routes/admin/email'
import { Route as AppIndexRouteImport } from './routes/app/index'
import { Route as AppActionCenterRouteImport } from './routes/app/action-center'
import { Route as AppAuditLogRouteImport } from './routes/app/audit-log'
import { Route as AppBilantRouteImport } from './routes/app/bilant'
import { Route as AppDashboardRouteImport } from './routes/app/dashboard'
import { Route as AppMyBuildingRouteImport } from './routes/app/my-building'
import { Route as AppNotificationsRouteImport } from './routes/app/notifications'
import { Route as AppOnboardingRouteImport } from './routes/app/onboarding'
import { Route as AppOwnerTenancyRouteImport } from './routes/app/owner-tenancy'
import { Route as AppSettingsRouteRouteImport } from './routes/app/settings/route'
import { Route as PortalIndexRouteImport } from './routes/portal/index'
import { Route as PortalBuildingRouteImport } from './routes/portal/building'
import { Route as PortalDocumentsRouteImport } from './routes/portal/documents'
import { Route as PortalMetersRouteImport } from './routes/portal/meters'
import { Route as PortalNotificationsRouteImport } from './routes/portal/notifications'
import { Route as PortalRentRouteImport } from './routes/portal/rent'
import { Route as PortalSettingsRouteImport } from './routes/portal/settings'
import { Route as AuthConfirmBecomeOwnerTokenRouteImport } from './routes/_auth/confirm-become-owner.$token'
import { Route as AuthConfirmDeletionTokenRouteImport } from './routes/_auth/confirm-deletion.$token'
import { Route as AuthConfirmEmailChangeTokenRouteImport } from './routes/_auth/confirm-email-change.$token'
import { Route as AuthInviteTokenRouteImport } from './routes/_auth/invite.$token'
import { Route as AuthMfaEnrollRouteImport } from './routes/_auth/mfa_.enroll'
import { Route as AuthPreluareProprietateTokenRouteImport } from './routes/_auth/preluare-proprietate.$token'
import { Route as AuthResetPasswordTokenRouteImport } from './routes/_auth/reset-password.$token'
import { Route as AuthSetPasswordTokenRouteImport } from './routes/_auth/set-password.$token'
import { Route as AuthVerifyEmailTokenRouteImport } from './routes/_auth/verify-email.$token'
import { Route as AppBankingIndexRouteImport } from './routes/app/banking/index'
import { Route as AppBuildingsIndexRouteImport } from './routes/app/buildings/index'
import { Route as AppBuildingsBuildingIdRouteImport } from './routes/app/buildings/$buildingId'
import { Route as AppContractsIndexRouteImport } from './routes/app/contracts/index'
import { Route as AppContractsContractIdRouteRouteImport } from './routes/app/contracts/$contractId/route'
import { Route as AppContractsNewRouteImport } from './routes/app/contracts/new'
import { Route as AppDocumentsIndexRouteImport } from './routes/app/documents/index'
import { Route as AppDocumentsDocumentIdRouteImport } from './routes/app/documents/$documentId'
import { Route as AppEquipmentIndexRouteImport } from './routes/app/equipment/index'
import { Route as AppEquipmentEquipmentIdRouteImport } from './routes/app/equipment/$equipmentId'
import { Route as AppEquipmentNewRouteImport } from './routes/app/equipment/new'
import { Route as AppExpensesIndexRouteImport } from './routes/app/expenses/index'
import { Route as AppExpensesCategoriesRouteImport } from './routes/app/expenses/categories'
import { Route as AppExpensesNewRouteImport } from './routes/app/expenses/new'
import { Route as AppExpensesRecurringRouteImport } from './routes/app/expenses/recurring'
import { Route as AppExpensesSuppliersRouteImport } from './routes/app/expenses/suppliers'
import { Route as AppFiscalIndexRouteImport } from './routes/app/fiscal/index'
import { Route as AppFiscalCalendarRouteImport } from './routes/app/fiscal/calendar'
import { Route as AppFiscalProfileRouteImport } from './routes/app/fiscal/profile'
import { Route as AppHealthIndexRouteImport } from './routes/app/health/index'
import { Route as AppHealthPropertyIdRouteImport } from './routes/app/health/$propertyId'
import { Route as AppInsuranceIndexRouteImport } from './routes/app/insurance/index'
import { Route as AppPropertiesIndexRouteImport } from './routes/app/properties/index'
import { Route as AppPropertiesPropertyIdRouteRouteImport } from './routes/app/properties/$propertyId/route'
import { Route as AppPropertiesNewRouteImport } from './routes/app/properties/new'
import { Route as AppRentIndexRouteImport } from './routes/app/rent/index'
import { Route as AppRentPaymentsRouteImport } from './routes/app/rent/payments'
import { Route as AppRepairsIndexRouteImport } from './routes/app/repairs/index'
import { Route as AppRepairsTicketIdRouteImport } from './routes/app/repairs/$ticketId'
import { Route as AppRepairsNewRouteImport } from './routes/app/repairs/new'
import { Route as AppReportsIndexRouteImport } from './routes/app/reports/index'
import { Route as AppReportsReportCodeRouteImport } from './routes/app/reports/$reportCode'
import { Route as AppReportsDosarFiscalRouteImport } from './routes/app/reports/dosar-fiscal'
import { Route as AppSettingsIndexRouteImport } from './routes/app/settings/index'
import { Route as AppSettingsGdprRouteImport } from './routes/app/settings/gdpr'
import { Route as AppSettingsMembersRouteImport } from './routes/app/settings/members'
import { Route as AppSettingsNotificationRulesRouteImport } from './routes/app/settings/notification-rules'
import { Route as AppSettingsProfileRouteImport } from './routes/app/settings/profile'
import { Route as AppSettingsSecurityRouteImport } from './routes/app/settings/security'
import { Route as AppTenantsIndexRouteImport } from './routes/app/tenants/index'
import { Route as AppTenantsTenantIdRouteRouteImport } from './routes/app/tenants/$tenantId/route'
import { Route as AppTenantsNewRouteImport } from './routes/app/tenants/new'
import { Route as AppUtilitiesIndexRouteImport } from './routes/app/utilities/index'
import { Route as LinkIncidentTokenRouteImport } from './routes/link/incident.$token'
import { Route as LinkMeterTokenRouteImport } from './routes/link/meter.$token'
import { Route as PortalIncidentsIndexRouteImport } from './routes/portal/incidents/index'
import { Route as PortalIncidentsIncidentIdRouteImport } from './routes/portal/incidents/$incidentId'
import { Route as AppContractsContractIdIndexRouteImport } from './routes/app/contracts/$contractId/index'
import { Route as AppContractsContractIdC168RouteImport } from './routes/app/contracts/$contractId/c168'
import { Route as AppContractsContractIdDepositRouteImport } from './routes/app/contracts/$contractId/deposit'
import { Route as AppContractsContractIdDocumentsRouteImport } from './routes/app/contracts/$contractId/documents'
import { Route as AppContractsContractIdEditRouteImport } from './routes/app/contracts/$contractId/edit'
import { Route as AppContractsContractIdScheduleRouteImport } from './routes/app/contracts/$contractId/schedule'
import { Route as AppDocumentsOcrDocumentIdRouteImport } from './routes/app/documents/ocr.$documentId'
import { Route as AppExpensesExpenseIdEditRouteImport } from './routes/app/expenses/$expenseId.edit'
import { Route as AppFiscalC168ObligationIdRouteImport } from './routes/app/fiscal/c168.$obligationId'
import { Route as AppFiscalDeclarationsDeclarationIdRouteRouteImport } from './routes/app/fiscal/declarations.$declarationId/route'
import { Route as AppPropertiesPropertyIdIndexRouteImport } from './routes/app/properties/$propertyId/index'
import { Route as AppPropertiesPropertyIdBuildingRouteImport } from './routes/app/properties/$propertyId/building'
import { Route as AppPropertiesPropertyIdCoOwnersRouteImport } from './routes/app/properties/$propertyId/co-owners'
import { Route as AppPropertiesPropertyIdContractsRouteImport } from './routes/app/properties/$propertyId/contracts'
import { Route as AppPropertiesPropertyIdCostsRouteImport } from './routes/app/properties/$propertyId/costs'
import { Route as AppPropertiesPropertyIdDocumentsRouteImport } from './routes/app/properties/$propertyId/documents'
import { Route as AppPropertiesPropertyIdEditRouteImport } from './routes/app/properties/$propertyId/edit'
import { Route as AppPropertiesPropertyIdEquipmentRouteImport } from './routes/app/properties/$propertyId/equipment'
import { Route as AppPropertiesPropertyIdInsuranceRouteImport } from './routes/app/properties/$propertyId/insurance'
import { Route as AppPropertiesPropertyIdInvestmentRouteImport } from './routes/app/properties/$propertyId/investment'
import { Route as AppPropertiesPropertyIdRepairsRouteImport } from './routes/app/properties/$propertyId/repairs'
import { Route as AppPropertiesPropertyIdUnitsRouteImport } from './routes/app/properties/$propertyId/units'
import { Route as AppPropertiesPropertyIdUtilitiesRouteImport } from './routes/app/properties/$propertyId/utilities'
import { Route as AppTenantsTenantIdIndexRouteImport } from './routes/app/tenants/$tenantId/index'
import { Route as AppTenantsTenantIdContactsRouteImport } from './routes/app/tenants/$tenantId/contacts'
import { Route as AppTenantsTenantIdDocumentsRouteImport } from './routes/app/tenants/$tenantId/documents'
import { Route as AppTenantsTenantIdEditRouteImport } from './routes/app/tenants/$tenantId/edit'
import { Route as AppTenantsTenantIdHistoryRouteImport } from './routes/app/tenants/$tenantId/history'
import { Route as AppTenantsTenantIdHomesRouteImport } from './routes/app/tenants/$tenantId/homes'
import { Route as AppTenantsTenantIdPaymentsRouteImport } from './routes/app/tenants/$tenantId/payments'
import { Route as AppTenantsTenantIdRepairsRouteImport } from './routes/app/tenants/$tenantId/repairs'
import { Route as AppUtilitiesServiceIdIndexRouteImport } from './routes/app/utilities/$serviceId/index'
import { Route as AppContractsContractIdAmendmentsIndexRouteImport } from './routes/app/contracts/$contractId/amendments/index'
import { Route as AppContractsContractIdAmendmentsNewRouteImport } from './routes/app/contracts/$contractId/amendments/new'
import { Route as AppFiscalDeclarationsDeclarationIdIndexRouteImport } from './routes/app/fiscal/declarations.$declarationId/index'
import { Route as AppFiscalDeclarationsDeclarationIdSubmissionRouteImport } from './routes/app/fiscal/declarations.$declarationId/submission'
import { Route as AppPropertiesPropertyIdRentIndexRouteImport } from './routes/app/properties/$propertyId/rent/index'
import { Route as AppPropertiesPropertyIdRentPaymentsRouteImport } from './routes/app/properties/$propertyId/rent/payments'
import { Route as AppUtilitiesServiceIdReadingsNewRouteImport } from './routes/app/utilities/$serviceId/readings.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRouteRoute = AdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRouteRoute = AppRouteRouteImport.update({
  id: '/app',
  path: '/app',
  getParentRoute: () => rootRouteImport,
} as any)
const BrandRoute = BrandRouteImport.update({
  id: '/brand',
  path: '/brand',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRouteRoute = PortalRouteRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMfaRoute = AuthMfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => AuthRoute,
} as any)
const AuthRegisterRoute = AuthRegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelectClientRoute = AuthSelectClientRouteImport.update({
  id: '/select-client',
  path: '/select-client',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSelectContractRoute = AuthSelectContractRouteImport.update({
  id: '/select-contract',
  path: '/select-contract',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUnsubscribedRoute = AuthUnsubscribedRouteImport.update({
  id: '/unsubscribed',
  path: '/unsubscribed',
  getParentRoute: () => AuthRoute,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAccountsRoute = AdminAccountsRouteImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAdminAuditRoute = AdminAdminAuditRouteImport.update({
  id: '/admin-audit',
  path: '/admin-audit',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminAuditRoute = AdminAuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AdminEmailRoute = AdminEmailRouteImport.update({
  id: '/email',
  path: '/email',
  getParentRoute: () => AdminRouteRoute,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppActionCenterRoute = AppActionCenterRouteImport.update({
  id: '/action-center',
  path: '/action-center',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppAuditLogRoute = AppAuditLogRouteImport.update({
  id: '/audit-log',
  path: '/audit-log',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBilantRoute = AppBilantRouteImport.update({
  id: '/bilant',
  path: '/bilant',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppMyBuildingRoute = AppMyBuildingRouteImport.update({
  id: '/my-building',
  path: '/my-building',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppOwnerTenancyRoute = AppOwnerTenancyRouteImport.update({
  id: '/owner-tenancy',
  path: '/owner-tenancy',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsRouteRoute = AppSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRouteRoute,
} as any)
const PortalIndexRoute = PortalIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalBuildingRoute = PortalBuildingRouteImport.update({
  id: '/building',
  path: '/building',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalDocumentsRoute = PortalDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalMetersRoute = PortalMetersRouteImport.update({
  id: '/meters',
  path: '/meters',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalNotificationsRoute = PortalNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalRentRoute = PortalRentRouteImport.update({
  id: '/rent',
  path: '/rent',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalSettingsRoute = PortalSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => PortalRouteRoute,
} as any)
const AuthConfirmBecomeOwnerTokenRoute =
  AuthConfirmBecomeOwnerTokenRouteImport.update({
    id: '/confirm-become-owner/$token',
    path: '/confirm-become-owner/$token',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConfirmDeletionTokenRoute =
  AuthConfirmDeletionTokenRouteImport.update({
    id: '/confirm-deletion/$token',
    path: '/confirm-deletion/$token',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthConfirmEmailChangeTokenRoute =
  AuthConfirmEmailChangeTokenRouteImport.update({
    id: '/confirm-email-change/$token',
    path: '/confirm-email-change/$token',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthInviteTokenRoute = AuthInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthMfaEnrollRoute = AuthMfaEnrollRouteImport.update({
  id: '/mfa_/enroll',
  path: '/mfa/enroll',
  getParentRoute: () => AuthRoute,
} as any)
const AuthPreluareProprietateTokenRoute =
  AuthPreluareProprietateTokenRouteImport.update({
    id: '/preluare-proprietate/$token',
    path: '/preluare-proprietate/$token',
    getParentRoute: () => AuthRoute,
  } as any)
const AuthResetPasswordTokenRoute = AuthResetPasswordTokenRouteImport.update({
  id: '/reset-password/$token',
  path: '/reset-password/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSetPasswordTokenRoute = AuthSetPasswordTokenRouteImport.update({
  id: '/set-password/$token',
  path: '/set-password/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AuthVerifyEmailTokenRoute = AuthVerifyEmailTokenRouteImport.update({
  id: '/verify-email/$token',
  path: '/verify-email/$token',
  getParentRoute: () => AuthRoute,
} as any)
const AppBankingIndexRoute = AppBankingIndexRouteImport.update({
  id: '/banking/',
  path: '/banking/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBuildingsIndexRoute = AppBuildingsIndexRouteImport.update({
  id: '/buildings/',
  path: '/buildings/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppBuildingsBuildingIdRoute = AppBuildingsBuildingIdRouteImport.update({
  id: '/buildings/$buildingId',
  path: '/buildings/$buildingId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContractsIndexRoute = AppContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppContractsContractIdRouteRoute =
  AppContractsContractIdRouteRouteImport.update({
    id: '/contracts/$contractId',
    path: '/contracts/$contractId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppContractsNewRoute = AppContractsNewRouteImport.update({
  id: '/contracts/new',
  path: '/contracts/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: '/documents/',
  path: '/documents/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppDocumentsDocumentIdRoute = AppDocumentsDocumentIdRouteImport.update({
  id: '/documents/$documentId',
  path: '/documents/$documentId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEquipmentIndexRoute = AppEquipmentIndexRouteImport.update({
  id: '/equipment/',
  path: '/equipment/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEquipmentEquipmentIdRoute = AppEquipmentEquipmentIdRouteImport.update({
  id: '/equipment/$equipmentId',
  path: '/equipment/$equipmentId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppEquipmentNewRoute = AppEquipmentNewRouteImport.update({
  id: '/equipment/new',
  path: '/equipment/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExpensesIndexRoute = AppExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExpensesCategoriesRoute = AppExpensesCategoriesRouteImport.update({
  id: '/expenses/categories',
  path: '/expenses/categories',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExpensesNewRoute = AppExpensesNewRouteImport.update({
  id: '/expenses/new',
  path: '/expenses/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExpensesRecurringRoute = AppExpensesRecurringRouteImport.update({
  id: '/expenses/recurring',
  path: '/expenses/recurring',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppExpensesSuppliersRoute = AppExpensesSuppliersRouteImport.update({
  id: '/expenses/suppliers',
  path: '/expenses/suppliers',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFiscalIndexRoute = AppFiscalIndexRouteImport.update({
  id: '/fiscal/',
  path: '/fiscal/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFiscalCalendarRoute = AppFiscalCalendarRouteImport.update({
  id: '/fiscal/calendar',
  path: '/fiscal/calendar',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppFiscalProfileRoute = AppFiscalProfileRouteImport.update({
  id: '/fiscal/profile',
  path: '/fiscal/profile',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHealthIndexRoute = AppHealthIndexRouteImport.update({
  id: '/health/',
  path: '/health/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppHealthPropertyIdRoute = AppHealthPropertyIdRouteImport.update({
  id: '/health/$propertyId',
  path: '/health/$propertyId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppInsuranceIndexRoute = AppInsuranceIndexRouteImport.update({
  id: '/insurance/',
  path: '/insurance/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPropertiesIndexRoute = AppPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppPropertiesPropertyIdRouteRoute =
  AppPropertiesPropertyIdRouteRouteImport.update({
    id: '/properties/$propertyId',
    path: '/properties/$propertyId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppPropertiesNewRoute = AppPropertiesNewRouteImport.update({
  id: '/properties/new',
  path: '/properties/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRentIndexRoute = AppRentIndexRouteImport.update({
  id: '/rent/',
  path: '/rent/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRentPaymentsRoute = AppRentPaymentsRouteImport.update({
  id: '/rent/payments',
  path: '/rent/payments',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRepairsIndexRoute = AppRepairsIndexRouteImport.update({
  id: '/repairs/',
  path: '/repairs/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRepairsTicketIdRoute = AppRepairsTicketIdRouteImport.update({
  id: '/repairs/$ticketId',
  path: '/repairs/$ticketId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppRepairsNewRoute = AppRepairsNewRouteImport.update({
  id: '/repairs/new',
  path: '/repairs/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportsReportCodeRoute = AppReportsReportCodeRouteImport.update({
  id: '/reports/$reportCode',
  path: '/reports/$reportCode',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppReportsDosarFiscalRoute = AppReportsDosarFiscalRouteImport.update({
  id: '/reports/dosar-fiscal',
  path: '/reports/dosar-fiscal',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsGdprRoute = AppSettingsGdprRouteImport.update({
  id: '/gdpr',
  path: '/gdpr',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsMembersRoute = AppSettingsMembersRouteImport.update({
  id: '/members',
  path: '/members',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsNotificationRulesRoute =
  AppSettingsNotificationRulesRouteImport.update({
    id: '/notification-rules',
    path: '/notification-rules',
    getParentRoute: () => AppSettingsRouteRoute,
  } as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => AppSettingsRouteRoute,
} as any)
const AppTenantsIndexRoute = AppTenantsIndexRouteImport.update({
  id: '/tenants/',
  path: '/tenants/',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTenantsTenantIdRouteRoute = AppTenantsTenantIdRouteRouteImport.update({
  id: '/tenants/$tenantId',
  path: '/tenants/$tenantId',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppTenantsNewRoute = AppTenantsNewRouteImport.update({
  id: '/tenants/new',
  path: '/tenants/new',
  getParentRoute: () => AppRouteRoute,
} as any)
const AppUtilitiesIndexRoute = AppUtilitiesIndexRouteImport.update({
  id: '/utilities/',
  path: '/utilities/',
  getParentRoute: () => AppRouteRoute,
} as any)
const LinkIncidentTokenRoute = LinkIncidentTokenRouteImport.update({
  id: '/link/incident/$token',
  path: '/link/incident/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkMeterTokenRoute = LinkMeterTokenRouteImport.update({
  id: '/link/meter/$token',
  path: '/link/meter/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalIncidentsIndexRoute = PortalIncidentsIndexRouteImport.update({
  id: '/incidents/',
  path: '/incidents/',
  getParentRoute: () => PortalRouteRoute,
} as any)
const PortalIncidentsIncidentIdRoute =
  PortalIncidentsIncidentIdRouteImport.update({
    id: '/incidents/$incidentId',
    path: '/incidents/$incidentId',
    getParentRoute: () => PortalRouteRoute,
  } as any)
const AppContractsContractIdIndexRoute =
  AppContractsContractIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppContractsContractIdC168Route =
  AppContractsContractIdC168RouteImport.update({
    id: '/c168',
    path: '/c168',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppContractsContractIdDepositRoute =
  AppContractsContractIdDepositRouteImport.update({
    id: '/deposit',
    path: '/deposit',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppContractsContractIdDocumentsRoute =
  AppContractsContractIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppContractsContractIdEditRoute =
  AppContractsContractIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppContractsContractIdScheduleRoute =
  AppContractsContractIdScheduleRouteImport.update({
    id: '/schedule',
    path: '/schedule',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppDocumentsOcrDocumentIdRoute =
  AppDocumentsOcrDocumentIdRouteImport.update({
    id: '/documents/ocr/$documentId',
    path: '/documents/ocr/$documentId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppExpensesExpenseIdEditRoute =
  AppExpensesExpenseIdEditRouteImport.update({
    id: '/expenses/$expenseId/edit',
    path: '/expenses/$expenseId/edit',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppFiscalC168ObligationIdRoute =
  AppFiscalC168ObligationIdRouteImport.update({
    id: '/fiscal/c168/$obligationId',
    path: '/fiscal/c168/$obligationId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppFiscalDeclarationsDeclarationIdRouteRoute =
  AppFiscalDeclarationsDeclarationIdRouteRouteImport.update({
    id: '/fiscal/declarations/$declarationId',
    path: '/fiscal/declarations/$declarationId',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppPropertiesPropertyIdIndexRoute =
  AppPropertiesPropertyIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdBuildingRoute =
  AppPropertiesPropertyIdBuildingRouteImport.update({
    id: '/building',
    path: '/building',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdCoOwnersRoute =
  AppPropertiesPropertyIdCoOwnersRouteImport.update({
    id: '/co-owners',
    path: '/co-owners',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdContractsRoute =
  AppPropertiesPropertyIdContractsRouteImport.update({
    id: '/contracts',
    path: '/contracts',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdCostsRoute =
  AppPropertiesPropertyIdCostsRouteImport.update({
    id: '/costs',
    path: '/costs',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdDocumentsRoute =
  AppPropertiesPropertyIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdEditRoute =
  AppPropertiesPropertyIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdEquipmentRoute =
  AppPropertiesPropertyIdEquipmentRouteImport.update({
    id: '/equipment',
    path: '/equipment',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdInsuranceRoute =
  AppPropertiesPropertyIdInsuranceRouteImport.update({
    id: '/insurance',
    path: '/insurance',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdInvestmentRoute =
  AppPropertiesPropertyIdInvestmentRouteImport.update({
    id: '/investment',
    path: '/investment',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdRepairsRoute =
  AppPropertiesPropertyIdRepairsRouteImport.update({
    id: '/repairs',
    path: '/repairs',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdUnitsRoute =
  AppPropertiesPropertyIdUnitsRouteImport.update({
    id: '/units',
    path: '/units',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdUtilitiesRoute =
  AppPropertiesPropertyIdUtilitiesRouteImport.update({
    id: '/utilities',
    path: '/utilities',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppTenantsTenantIdIndexRoute = AppTenantsTenantIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppTenantsTenantIdRouteRoute,
} as any)
const AppTenantsTenantIdContactsRoute =
  AppTenantsTenantIdContactsRouteImport.update({
    id: '/contacts',
    path: '/contacts',
    getParentRoute: () => AppTenantsTenantIdRouteRoute,
  } as any)
const AppTenantsTenantIdDocumentsRoute =
  AppTenantsTenantIdDocumentsRouteImport.update({
    id: '/documents',
    path: '/documents',
    getParentRoute: () => AppTenantsTenantIdRouteRoute,
  } as any)
const AppTenantsTenantIdEditRoute = AppTenantsTenantIdEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => AppTenantsTenantIdRouteRoute,
} as any)
const AppTenantsTenantIdHistoryRoute =
  AppTenantsTenantIdHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AppTenantsTenantIdRouteRoute,
  } as any)
const AppTenantsTenantIdHomesRoute = AppTenantsTenantIdHomesRouteImport.update({
  id: '/homes',
  path: '/homes',
  getParentRoute: () => AppTenantsTenantIdRouteRoute,
} as any)
const AppTenantsTenantIdPaymentsRoute =
  AppTenantsTenantIdPaymentsRouteImport.update({
    id: '/payments',
    path: '/payments',
    getParentRoute: () => AppTenantsTenantIdRouteRoute,
  } as any)
const AppTenantsTenantIdRepairsRoute =
  AppTenantsTenantIdRepairsRouteImport.update({
    id: '/repairs',
    path: '/repairs',
    getParentRoute: () => AppTenantsTenantIdRouteRoute,
  } as any)
const AppUtilitiesServiceIdIndexRoute =
  AppUtilitiesServiceIdIndexRouteImport.update({
    id: '/utilities/$serviceId/',
    path: '/utilities/$serviceId/',
    getParentRoute: () => AppRouteRoute,
  } as any)
const AppContractsContractIdAmendmentsIndexRoute =
  AppContractsContractIdAmendmentsIndexRouteImport.update({
    id: '/amendments/',
    path: '/amendments/',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppContractsContractIdAmendmentsNewRoute =
  AppContractsContractIdAmendmentsNewRouteImport.update({
    id: '/amendments/new',
    path: '/amendments/new',
    getParentRoute: () => AppContractsContractIdRouteRoute,
  } as any)
const AppFiscalDeclarationsDeclarationIdIndexRoute =
  AppFiscalDeclarationsDeclarationIdIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AppFiscalDeclarationsDeclarationIdRouteRoute,
  } as any)
const AppFiscalDeclarationsDeclarationIdSubmissionRoute =
  AppFiscalDeclarationsDeclarationIdSubmissionRouteImport.update({
    id: '/submission',
    path: '/submission',
    getParentRoute: () => AppFiscalDeclarationsDeclarationIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdRentIndexRoute =
  AppPropertiesPropertyIdRentIndexRouteImport.update({
    id: '/rent/',
    path: '/rent/',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppPropertiesPropertyIdRentPaymentsRoute =
  AppPropertiesPropertyIdRentPaymentsRouteImport.update({
    id: '/rent/payments',
    path: '/rent/payments',
    getParentRoute: () => AppPropertiesPropertyIdRouteRoute,
  } as any)
const AppUtilitiesServiceIdReadingsNewRoute =
  AppUtilitiesServiceIdReadingsNewRouteImport.update({
    id: '/utilities/$serviceId/readings/new',
    path: '/utilities/$serviceId/readings/new',
    getParentRoute: () => AppRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/portal': typeof PortalRouteRouteWithChildren
  '/brand': typeof BrandRoute
  '/demo': typeof DemoRoute
  '/app/settings': typeof AppSettingsRouteRouteWithChildren
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/mfa': typeof AuthMfaRoute
  '/register': typeof AuthRegisterRoute
  '/select-client': typeof AuthSelectClientRoute
  '/select-contract': typeof AuthSelectContractRoute
  '/unsubscribed': typeof AuthUnsubscribedRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/admin-audit': typeof AdminAdminAuditRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/email': typeof AdminEmailRoute
  '/app/action-center': typeof AppActionCenterRoute
  '/app/audit-log': typeof AppAuditLogRoute
  '/app/bilant': typeof AppBilantRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/my-building': typeof AppMyBuildingRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/owner-tenancy': typeof AppOwnerTenancyRoute
  '/portal/building': typeof PortalBuildingRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/meters': typeof PortalMetersRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/rent': typeof PortalRentRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/app/contracts/$contractId': typeof AppContractsContractIdRouteRouteWithChildren
  '/app/properties/$propertyId': typeof AppPropertiesPropertyIdRouteRouteWithChildren
  '/app/tenants/$tenantId': typeof AppTenantsTenantIdRouteRouteWithChildren
  '/confirm-become-owner/$token': typeof AuthConfirmBecomeOwnerTokenRoute
  '/confirm-deletion/$token': typeof AuthConfirmDeletionTokenRoute
  '/confirm-email-change/$token': typeof AuthConfirmEmailChangeTokenRoute
  '/invite/$token': typeof AuthInviteTokenRoute
  '/mfa/enroll': typeof AuthMfaEnrollRoute
  '/preluare-proprietate/$token': typeof AuthPreluareProprietateTokenRoute
  '/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/set-password/$token': typeof AuthSetPasswordTokenRoute
  '/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/app/buildings/$buildingId': typeof AppBuildingsBuildingIdRoute
  '/app/contracts/new': typeof AppContractsNewRoute
  '/app/documents/$documentId': typeof AppDocumentsDocumentIdRoute
  '/app/equipment/$equipmentId': typeof AppEquipmentEquipmentIdRoute
  '/app/equipment/new': typeof AppEquipmentNewRoute
  '/app/expenses/categories': typeof AppExpensesCategoriesRoute
  '/app/expenses/new': typeof AppExpensesNewRoute
  '/app/expenses/recurring': typeof AppExpensesRecurringRoute
  '/app/expenses/suppliers': typeof AppExpensesSuppliersRoute
  '/app/fiscal/calendar': typeof AppFiscalCalendarRoute
  '/app/fiscal/profile': typeof AppFiscalProfileRoute
  '/app/health/$propertyId': typeof AppHealthPropertyIdRoute
  '/app/properties/new': typeof AppPropertiesNewRoute
  '/app/rent/payments': typeof AppRentPaymentsRoute
  '/app/repairs/$ticketId': typeof AppRepairsTicketIdRoute
  '/app/repairs/new': typeof AppRepairsNewRoute
  '/app/reports/$reportCode': typeof AppReportsReportCodeRoute
  '/app/reports/dosar-fiscal': typeof AppReportsDosarFiscalRoute
  '/app/settings/gdpr': typeof AppSettingsGdprRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/settings/notification-rules': typeof AppSettingsNotificationRulesRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/settings/security': typeof AppSettingsSecurityRoute
  '/app/tenants/new': typeof AppTenantsNewRoute
  '/link/incident/$token': typeof LinkIncidentTokenRoute
  '/link/meter/$token': typeof LinkMeterTokenRoute
  '/portal/incidents/$incidentId': typeof PortalIncidentsIncidentIdRoute
  '/app/banking/': typeof AppBankingIndexRoute
  '/app/buildings/': typeof AppBuildingsIndexRoute
  '/app/contracts/': typeof AppContractsIndexRoute
  '/app/documents/': typeof AppDocumentsIndexRoute
  '/app/equipment/': typeof AppEquipmentIndexRoute
  '/app/expenses/': typeof AppExpensesIndexRoute
  '/app/fiscal/': typeof AppFiscalIndexRoute
  '/app/health/': typeof AppHealthIndexRoute
  '/app/insurance/': typeof AppInsuranceIndexRoute
  '/app/properties/': typeof AppPropertiesIndexRoute
  '/app/rent/': typeof AppRentIndexRoute
  '/app/repairs/': typeof AppRepairsIndexRoute
  '/app/reports/': typeof AppReportsIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/tenants/': typeof AppTenantsIndexRoute
  '/app/utilities/': typeof AppUtilitiesIndexRoute
  '/portal/incidents/': typeof PortalIncidentsIndexRoute
  '/app/fiscal/declarations/$declarationId': typeof AppFiscalDeclarationsDeclarationIdRouteRouteWithChildren
  '/app/contracts/$contractId/c168': typeof AppContractsContractIdC168Route
  '/app/contracts/$contractId/deposit': typeof AppContractsContractIdDepositRoute
  '/app/contracts/$contractId/documents': typeof AppContractsContractIdDocumentsRoute
  '/app/contracts/$contractId/edit': typeof AppContractsContractIdEditRoute
  '/app/contracts/$contractId/schedule': typeof AppContractsContractIdScheduleRoute
  '/app/documents/ocr/$documentId': typeof AppDocumentsOcrDocumentIdRoute
  '/app/expenses/$expenseId/edit': typeof AppExpensesExpenseIdEditRoute
  '/app/fiscal/c168/$obligationId': typeof AppFiscalC168ObligationIdRoute
  '/app/properties/$propertyId/building': typeof AppPropertiesPropertyIdBuildingRoute
  '/app/properties/$propertyId/co-owners': typeof AppPropertiesPropertyIdCoOwnersRoute
  '/app/properties/$propertyId/contracts': typeof AppPropertiesPropertyIdContractsRoute
  '/app/properties/$propertyId/costs': typeof AppPropertiesPropertyIdCostsRoute
  '/app/properties/$propertyId/documents': typeof AppPropertiesPropertyIdDocumentsRoute
  '/app/properties/$propertyId/edit': typeof AppPropertiesPropertyIdEditRoute
  '/app/properties/$propertyId/equipment': typeof AppPropertiesPropertyIdEquipmentRoute
  '/app/properties/$propertyId/insurance': typeof AppPropertiesPropertyIdInsuranceRoute
  '/app/properties/$propertyId/investment': typeof AppPropertiesPropertyIdInvestmentRoute
  '/app/properties/$propertyId/repairs': typeof AppPropertiesPropertyIdRepairsRoute
  '/app/properties/$propertyId/units': typeof AppPropertiesPropertyIdUnitsRoute
  '/app/properties/$propertyId/utilities': typeof AppPropertiesPropertyIdUtilitiesRoute
  '/app/tenants/$tenantId/contacts': typeof AppTenantsTenantIdContactsRoute
  '/app/tenants/$tenantId/documents': typeof AppTenantsTenantIdDocumentsRoute
  '/app/tenants/$tenantId/edit': typeof AppTenantsTenantIdEditRoute
  '/app/tenants/$tenantId/history': typeof AppTenantsTenantIdHistoryRoute
  '/app/tenants/$tenantId/homes': typeof AppTenantsTenantIdHomesRoute
  '/app/tenants/$tenantId/payments': typeof AppTenantsTenantIdPaymentsRoute
  '/app/tenants/$tenantId/repairs': typeof AppTenantsTenantIdRepairsRoute
  '/app/contracts/$contractId/': typeof AppContractsContractIdIndexRoute
  '/app/properties/$propertyId/': typeof AppPropertiesPropertyIdIndexRoute
  '/app/tenants/$tenantId/': typeof AppTenantsTenantIdIndexRoute
  '/app/utilities/$serviceId/': typeof AppUtilitiesServiceIdIndexRoute
  '/app/contracts/$contractId/amendments/new': typeof AppContractsContractIdAmendmentsNewRoute
  '/app/fiscal/declarations/$declarationId/submission': typeof AppFiscalDeclarationsDeclarationIdSubmissionRoute
  '/app/properties/$propertyId/rent/payments': typeof AppPropertiesPropertyIdRentPaymentsRoute
  '/app/utilities/$serviceId/readings/new': typeof AppUtilitiesServiceIdReadingsNewRoute
  '/app/contracts/$contractId/amendments/': typeof AppContractsContractIdAmendmentsIndexRoute
  '/app/fiscal/declarations/$declarationId/': typeof AppFiscalDeclarationsDeclarationIdIndexRoute
  '/app/properties/$propertyId/rent/': typeof AppPropertiesPropertyIdRentIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/brand': typeof BrandRoute
  '/demo': typeof DemoRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/mfa': typeof AuthMfaRoute
  '/register': typeof AuthRegisterRoute
  '/select-client': typeof AuthSelectClientRoute
  '/select-contract': typeof AuthSelectContractRoute
  '/unsubscribed': typeof AuthUnsubscribedRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/admin-audit': typeof AdminAdminAuditRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/email': typeof AdminEmailRoute
  '/app/action-center': typeof AppActionCenterRoute
  '/app/audit-log': typeof AppAuditLogRoute
  '/app/bilant': typeof AppBilantRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/my-building': typeof AppMyBuildingRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/owner-tenancy': typeof AppOwnerTenancyRoute
  '/portal/building': typeof PortalBuildingRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/meters': typeof PortalMetersRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/rent': typeof PortalRentRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/admin': typeof AdminIndexRoute
  '/app': typeof AppIndexRoute
  '/portal': typeof PortalIndexRoute
  '/confirm-become-owner/$token': typeof AuthConfirmBecomeOwnerTokenRoute
  '/confirm-deletion/$token': typeof AuthConfirmDeletionTokenRoute
  '/confirm-email-change/$token': typeof AuthConfirmEmailChangeTokenRoute
  '/invite/$token': typeof AuthInviteTokenRoute
  '/mfa/enroll': typeof AuthMfaEnrollRoute
  '/preluare-proprietate/$token': typeof AuthPreluareProprietateTokenRoute
  '/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/set-password/$token': typeof AuthSetPasswordTokenRoute
  '/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/app/buildings/$buildingId': typeof AppBuildingsBuildingIdRoute
  '/app/contracts/new': typeof AppContractsNewRoute
  '/app/documents/$documentId': typeof AppDocumentsDocumentIdRoute
  '/app/equipment/$equipmentId': typeof AppEquipmentEquipmentIdRoute
  '/app/equipment/new': typeof AppEquipmentNewRoute
  '/app/expenses/categories': typeof AppExpensesCategoriesRoute
  '/app/expenses/new': typeof AppExpensesNewRoute
  '/app/expenses/recurring': typeof AppExpensesRecurringRoute
  '/app/expenses/suppliers': typeof AppExpensesSuppliersRoute
  '/app/fiscal/calendar': typeof AppFiscalCalendarRoute
  '/app/fiscal/profile': typeof AppFiscalProfileRoute
  '/app/health/$propertyId': typeof AppHealthPropertyIdRoute
  '/app/properties/new': typeof AppPropertiesNewRoute
  '/app/rent/payments': typeof AppRentPaymentsRoute
  '/app/repairs/$ticketId': typeof AppRepairsTicketIdRoute
  '/app/repairs/new': typeof AppRepairsNewRoute
  '/app/reports/$reportCode': typeof AppReportsReportCodeRoute
  '/app/reports/dosar-fiscal': typeof AppReportsDosarFiscalRoute
  '/app/settings/gdpr': typeof AppSettingsGdprRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/settings/notification-rules': typeof AppSettingsNotificationRulesRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/settings/security': typeof AppSettingsSecurityRoute
  '/app/tenants/new': typeof AppTenantsNewRoute
  '/link/incident/$token': typeof LinkIncidentTokenRoute
  '/link/meter/$token': typeof LinkMeterTokenRoute
  '/portal/incidents/$incidentId': typeof PortalIncidentsIncidentIdRoute
  '/app/banking': typeof AppBankingIndexRoute
  '/app/buildings': typeof AppBuildingsIndexRoute
  '/app/contracts': typeof AppContractsIndexRoute
  '/app/documents': typeof AppDocumentsIndexRoute
  '/app/equipment': typeof AppEquipmentIndexRoute
  '/app/expenses': typeof AppExpensesIndexRoute
  '/app/fiscal': typeof AppFiscalIndexRoute
  '/app/health': typeof AppHealthIndexRoute
  '/app/insurance': typeof AppInsuranceIndexRoute
  '/app/properties': typeof AppPropertiesIndexRoute
  '/app/rent': typeof AppRentIndexRoute
  '/app/repairs': typeof AppRepairsIndexRoute
  '/app/reports': typeof AppReportsIndexRoute
  '/app/settings': typeof AppSettingsIndexRoute
  '/app/tenants': typeof AppTenantsIndexRoute
  '/app/utilities': typeof AppUtilitiesIndexRoute
  '/portal/incidents': typeof PortalIncidentsIndexRoute
  '/app/contracts/$contractId/c168': typeof AppContractsContractIdC168Route
  '/app/contracts/$contractId/deposit': typeof AppContractsContractIdDepositRoute
  '/app/contracts/$contractId/documents': typeof AppContractsContractIdDocumentsRoute
  '/app/contracts/$contractId/edit': typeof AppContractsContractIdEditRoute
  '/app/contracts/$contractId/schedule': typeof AppContractsContractIdScheduleRoute
  '/app/documents/ocr/$documentId': typeof AppDocumentsOcrDocumentIdRoute
  '/app/expenses/$expenseId/edit': typeof AppExpensesExpenseIdEditRoute
  '/app/fiscal/c168/$obligationId': typeof AppFiscalC168ObligationIdRoute
  '/app/properties/$propertyId/building': typeof AppPropertiesPropertyIdBuildingRoute
  '/app/properties/$propertyId/co-owners': typeof AppPropertiesPropertyIdCoOwnersRoute
  '/app/properties/$propertyId/contracts': typeof AppPropertiesPropertyIdContractsRoute
  '/app/properties/$propertyId/costs': typeof AppPropertiesPropertyIdCostsRoute
  '/app/properties/$propertyId/documents': typeof AppPropertiesPropertyIdDocumentsRoute
  '/app/properties/$propertyId/edit': typeof AppPropertiesPropertyIdEditRoute
  '/app/properties/$propertyId/equipment': typeof AppPropertiesPropertyIdEquipmentRoute
  '/app/properties/$propertyId/insurance': typeof AppPropertiesPropertyIdInsuranceRoute
  '/app/properties/$propertyId/investment': typeof AppPropertiesPropertyIdInvestmentRoute
  '/app/properties/$propertyId/repairs': typeof AppPropertiesPropertyIdRepairsRoute
  '/app/properties/$propertyId/units': typeof AppPropertiesPropertyIdUnitsRoute
  '/app/properties/$propertyId/utilities': typeof AppPropertiesPropertyIdUtilitiesRoute
  '/app/tenants/$tenantId/contacts': typeof AppTenantsTenantIdContactsRoute
  '/app/tenants/$tenantId/documents': typeof AppTenantsTenantIdDocumentsRoute
  '/app/tenants/$tenantId/edit': typeof AppTenantsTenantIdEditRoute
  '/app/tenants/$tenantId/history': typeof AppTenantsTenantIdHistoryRoute
  '/app/tenants/$tenantId/homes': typeof AppTenantsTenantIdHomesRoute
  '/app/tenants/$tenantId/payments': typeof AppTenantsTenantIdPaymentsRoute
  '/app/tenants/$tenantId/repairs': typeof AppTenantsTenantIdRepairsRoute
  '/app/contracts/$contractId': typeof AppContractsContractIdIndexRoute
  '/app/properties/$propertyId': typeof AppPropertiesPropertyIdIndexRoute
  '/app/tenants/$tenantId': typeof AppTenantsTenantIdIndexRoute
  '/app/utilities/$serviceId': typeof AppUtilitiesServiceIdIndexRoute
  '/app/contracts/$contractId/amendments/new': typeof AppContractsContractIdAmendmentsNewRoute
  '/app/fiscal/declarations/$declarationId/submission': typeof AppFiscalDeclarationsDeclarationIdSubmissionRoute
  '/app/properties/$propertyId/rent/payments': typeof AppPropertiesPropertyIdRentPaymentsRoute
  '/app/utilities/$serviceId/readings/new': typeof AppUtilitiesServiceIdReadingsNewRoute
  '/app/contracts/$contractId/amendments': typeof AppContractsContractIdAmendmentsIndexRoute
  '/app/fiscal/declarations/$declarationId': typeof AppFiscalDeclarationsDeclarationIdIndexRoute
  '/app/properties/$propertyId/rent': typeof AppPropertiesPropertyIdRentIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteRouteWithChildren
  '/app': typeof AppRouteRouteWithChildren
  '/portal': typeof PortalRouteRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/brand': typeof BrandRoute
  '/demo': typeof DemoRoute
  '/app/settings': typeof AppSettingsRouteRouteWithChildren
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/mfa': typeof AuthMfaRoute
  '/_auth/register': typeof AuthRegisterRoute
  '/_auth/select-client': typeof AuthSelectClientRoute
  '/_auth/select-contract': typeof AuthSelectContractRoute
  '/_auth/unsubscribed': typeof AuthUnsubscribedRoute
  '/admin/accounts': typeof AdminAccountsRoute
  '/admin/admin-audit': typeof AdminAdminAuditRoute
  '/admin/audit': typeof AdminAuditRoute
  '/admin/email': typeof AdminEmailRoute
  '/app/action-center': typeof AppActionCenterRoute
  '/app/audit-log': typeof AppAuditLogRoute
  '/app/bilant': typeof AppBilantRoute
  '/app/dashboard': typeof AppDashboardRoute
  '/app/my-building': typeof AppMyBuildingRoute
  '/app/notifications': typeof AppNotificationsRoute
  '/app/onboarding': typeof AppOnboardingRoute
  '/app/owner-tenancy': typeof AppOwnerTenancyRoute
  '/portal/building': typeof PortalBuildingRoute
  '/portal/documents': typeof PortalDocumentsRoute
  '/portal/meters': typeof PortalMetersRoute
  '/portal/notifications': typeof PortalNotificationsRoute
  '/portal/rent': typeof PortalRentRoute
  '/portal/settings': typeof PortalSettingsRoute
  '/admin/': typeof AdminIndexRoute
  '/app/': typeof AppIndexRoute
  '/portal/': typeof PortalIndexRoute
  '/app/contracts/$contractId': typeof AppContractsContractIdRouteRouteWithChildren
  '/app/properties/$propertyId': typeof AppPropertiesPropertyIdRouteRouteWithChildren
  '/app/tenants/$tenantId': typeof AppTenantsTenantIdRouteRouteWithChildren
  '/_auth/confirm-become-owner/$token': typeof AuthConfirmBecomeOwnerTokenRoute
  '/_auth/confirm-deletion/$token': typeof AuthConfirmDeletionTokenRoute
  '/_auth/confirm-email-change/$token': typeof AuthConfirmEmailChangeTokenRoute
  '/_auth/invite/$token': typeof AuthInviteTokenRoute
  '/_auth/mfa_/enroll': typeof AuthMfaEnrollRoute
  '/_auth/preluare-proprietate/$token': typeof AuthPreluareProprietateTokenRoute
  '/_auth/reset-password/$token': typeof AuthResetPasswordTokenRoute
  '/_auth/set-password/$token': typeof AuthSetPasswordTokenRoute
  '/_auth/verify-email/$token': typeof AuthVerifyEmailTokenRoute
  '/app/buildings/$buildingId': typeof AppBuildingsBuildingIdRoute
  '/app/contracts/new': typeof AppContractsNewRoute
  '/app/documents/$documentId': typeof AppDocumentsDocumentIdRoute
  '/app/equipment/$equipmentId': typeof AppEquipmentEquipmentIdRoute
  '/app/equipment/new': typeof AppEquipmentNewRoute
  '/app/expenses/categories': typeof AppExpensesCategoriesRoute
  '/app/expenses/new': typeof AppExpensesNewRoute
  '/app/expenses/recurring': typeof AppExpensesRecurringRoute
  '/app/expenses/suppliers': typeof AppExpensesSuppliersRoute
  '/app/fiscal/calendar': typeof AppFiscalCalendarRoute
  '/app/fiscal/profile': typeof AppFiscalProfileRoute
  '/app/health/$propertyId': typeof AppHealthPropertyIdRoute
  '/app/properties/new': typeof AppPropertiesNewRoute
  '/app/rent/payments': typeof AppRentPaymentsRoute
  '/app/repairs/$ticketId': typeof AppRepairsTicketIdRoute
  '/app/repairs/new': typeof AppRepairsNewRoute
  '/app/reports/$reportCode': typeof AppReportsReportCodeRoute
  '/app/reports/dosar-fiscal': typeof AppReportsDosarFiscalRoute
  '/app/settings/gdpr': typeof AppSettingsGdprRoute
  '/app/settings/members': typeof AppSettingsMembersRoute
  '/app/settings/notification-rules': typeof AppSettingsNotificationRulesRoute
  '/app/settings/profile': typeof AppSettingsProfileRoute
  '/app/settings/security': typeof AppSettingsSecurityRoute
  '/app/tenants/new': typeof AppTenantsNewRoute
  '/link/incident/$token': typeof LinkIncidentTokenRoute
  '/link/meter/$token': typeof LinkMeterTokenRoute
  '/portal/incidents/$incidentId': typeof PortalIncidentsIncidentIdRoute
  '/app/banking/': typeof AppBankingIndexRoute
  '/app/buildings/': typeof AppBuildingsIndexRoute
  '/app/contracts/': typeof AppContractsIndexRoute
  '/app/documents/': typeof AppDocumentsIndexRoute
  '/app/equipment/': typeof AppEquipmentIndexRoute
  '/app/expenses/': typeof AppExpensesIndexRoute
  '/app/fiscal/': typeof AppFiscalIndexRoute
  '/app/health/': typeof AppHealthIndexRoute
  '/app/insurance/': typeof AppInsuranceIndexRoute
  '/app/properties/': typeof AppPropertiesIndexRoute
  '/app/rent/': typeof AppRentIndexRoute
  '/app/repairs/': typeof AppRepairsIndexRoute
  '/app/reports/': typeof AppReportsIndexRoute
  '/app/settings/': typeof AppSettingsIndexRoute
  '/app/tenants/': typeof AppTenantsIndexRoute
  '/app/utilities/': typeof AppUtilitiesIndexRoute
  '/portal/incidents/': typeof PortalIncidentsIndexRoute
  '/app/fiscal/declarations/$declarationId': typeof AppFiscalDeclarationsDeclarationIdRouteRouteWithChildren
  '/app/contracts/$contractId/c168': typeof AppContractsContractIdC168Route
  '/app/contracts/$contractId/deposit': typeof AppContractsContractIdDepositRoute
  '/app/contracts/$contractId/documents': typeof AppContractsContractIdDocumentsRoute
  '/app/contracts/$contractId/edit': typeof AppContractsContractIdEditRoute
  '/app/contracts/$contractId/schedule': typeof AppContractsContractIdScheduleRoute
  '/app/documents/ocr/$documentId': typeof AppDocumentsOcrDocumentIdRoute
  '/app/expenses/$expenseId/edit': typeof AppExpensesExpenseIdEditRoute
  '/app/fiscal/c168/$obligationId': typeof AppFiscalC168ObligationIdRoute
  '/app/properties/$propertyId/building': typeof AppPropertiesPropertyIdBuildingRoute
  '/app/properties/$propertyId/co-owners': typeof AppPropertiesPropertyIdCoOwnersRoute
  '/app/properties/$propertyId/contracts': typeof AppPropertiesPropertyIdContractsRoute
  '/app/properties/$propertyId/costs': typeof AppPropertiesPropertyIdCostsRoute
  '/app/properties/$propertyId/documents': typeof AppPropertiesPropertyIdDocumentsRoute
  '/app/properties/$propertyId/edit': typeof AppPropertiesPropertyIdEditRoute
  '/app/properties/$propertyId/equipment': typeof AppPropertiesPropertyIdEquipmentRoute
  '/app/properties/$propertyId/insurance': typeof AppPropertiesPropertyIdInsuranceRoute
  '/app/properties/$propertyId/investment': typeof AppPropertiesPropertyIdInvestmentRoute
  '/app/properties/$propertyId/repairs': typeof AppPropertiesPropertyIdRepairsRoute
  '/app/properties/$propertyId/units': typeof AppPropertiesPropertyIdUnitsRoute
  '/app/properties/$propertyId/utilities': typeof AppPropertiesPropertyIdUtilitiesRoute
  '/app/tenants/$tenantId/contacts': typeof AppTenantsTenantIdContactsRoute
  '/app/tenants/$tenantId/documents': typeof AppTenantsTenantIdDocumentsRoute
  '/app/tenants/$tenantId/edit': typeof AppTenantsTenantIdEditRoute
  '/app/tenants/$tenantId/history': typeof AppTenantsTenantIdHistoryRoute
  '/app/tenants/$tenantId/homes': typeof AppTenantsTenantIdHomesRoute
  '/app/tenants/$tenantId/payments': typeof AppTenantsTenantIdPaymentsRoute
  '/app/tenants/$tenantId/repairs': typeof AppTenantsTenantIdRepairsRoute
  '/app/contracts/$contractId/': typeof AppContractsContractIdIndexRoute
  '/app/properties/$propertyId/': typeof AppPropertiesPropertyIdIndexRoute
  '/app/tenants/$tenantId/': typeof AppTenantsTenantIdIndexRoute
  '/app/utilities/$serviceId/': typeof AppUtilitiesServiceIdIndexRoute
  '/app/contracts/$contractId/amendments/new': typeof AppContractsContractIdAmendmentsNewRoute
  '/app/fiscal/declarations/$declarationId/submission': typeof AppFiscalDeclarationsDeclarationIdSubmissionRoute
  '/app/properties/$propertyId/rent/payments': typeof AppPropertiesPropertyIdRentPaymentsRoute
  '/app/utilities/$serviceId/readings/new': typeof AppUtilitiesServiceIdReadingsNewRoute
  '/app/contracts/$contractId/amendments/': typeof AppContractsContractIdAmendmentsIndexRoute
  '/app/fiscal/declarations/$declarationId/': typeof AppFiscalDeclarationsDeclarationIdIndexRoute
  '/app/properties/$propertyId/rent/': typeof AppPropertiesPropertyIdRentIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/app'
    | '/portal'
    | '/brand'
    | '/demo'
    | '/app/settings'
    | '/forgot-password'
    | '/login'
    | '/mfa'
    | '/register'
    | '/select-client'
    | '/select-contract'
    | '/unsubscribed'
    | '/admin/accounts'
    | '/admin/admin-audit'
    | '/admin/audit'
    | '/admin/email'
    | '/app/action-center'
    | '/app/audit-log'
    | '/app/bilant'
    | '/app/dashboard'
    | '/app/my-building'
    | '/app/notifications'
    | '/app/onboarding'
    | '/app/owner-tenancy'
    | '/portal/building'
    | '/portal/documents'
    | '/portal/meters'
    | '/portal/notifications'
    | '/portal/rent'
    | '/portal/settings'
    | '/admin/'
    | '/app/'
    | '/portal/'
    | '/app/contracts/$contractId'
    | '/app/properties/$propertyId'
    | '/app/tenants/$tenantId'
    | '/confirm-become-owner/$token'
    | '/confirm-deletion/$token'
    | '/confirm-email-change/$token'
    | '/invite/$token'
    | '/mfa/enroll'
    | '/preluare-proprietate/$token'
    | '/reset-password/$token'
    | '/set-password/$token'
    | '/verify-email/$token'
    | '/app/buildings/$buildingId'
    | '/app/contracts/new'
    | '/app/documents/$documentId'
    | '/app/equipment/$equipmentId'
    | '/app/equipment/new'
    | '/app/expenses/categories'
    | '/app/expenses/new'
    | '/app/expenses/recurring'
    | '/app/expenses/suppliers'
    | '/app/fiscal/calendar'
    | '/app/fiscal/profile'
    | '/app/health/$propertyId'
    | '/app/properties/new'
    | '/app/rent/payments'
    | '/app/repairs/$ticketId'
    | '/app/repairs/new'
    | '/app/reports/$reportCode'
    | '/app/reports/dosar-fiscal'
    | '/app/settings/gdpr'
    | '/app/settings/members'
    | '/app/settings/notification-rules'
    | '/app/settings/profile'
    | '/app/settings/security'
    | '/app/tenants/new'
    | '/link/incident/$token'
    | '/link/meter/$token'
    | '/portal/incidents/$incidentId'
    | '/app/banking/'
    | '/app/buildings/'
    | '/app/contracts/'
    | '/app/documents/'
    | '/app/equipment/'
    | '/app/expenses/'
    | '/app/fiscal/'
    | '/app/health/'
    | '/app/insurance/'
    | '/app/properties/'
    | '/app/rent/'
    | '/app/repairs/'
    | '/app/reports/'
    | '/app/settings/'
    | '/app/tenants/'
    | '/app/utilities/'
    | '/portal/incidents/'
    | '/app/fiscal/declarations/$declarationId'
    | '/app/contracts/$contractId/c168'
    | '/app/contracts/$contractId/deposit'
    | '/app/contracts/$contractId/documents'
    | '/app/contracts/$contractId/edit'
    | '/app/contracts/$contractId/schedule'
    | '/app/documents/ocr/$documentId'
    | '/app/expenses/$expenseId/edit'
    | '/app/fiscal/c168/$obligationId'
    | '/app/properties/$propertyId/building'
    | '/app/properties/$propertyId/co-owners'
    | '/app/properties/$propertyId/contracts'
    | '/app/properties/$propertyId/costs'
    | '/app/properties/$propertyId/documents'
    | '/app/properties/$propertyId/edit'
    | '/app/properties/$propertyId/equipment'
    | '/app/properties/$propertyId/insurance'
    | '/app/properties/$propertyId/investment'
    | '/app/properties/$propertyId/repairs'
    | '/app/properties/$propertyId/units'
    | '/app/properties/$propertyId/utilities'
    | '/app/tenants/$tenantId/contacts'
    | '/app/tenants/$tenantId/documents'
    | '/app/tenants/$tenantId/edit'
    | '/app/tenants/$tenantId/history'
    | '/app/tenants/$tenantId/homes'
    | '/app/tenants/$tenantId/payments'
    | '/app/tenants/$tenantId/repairs'
    | '/app/contracts/$contractId/'
    | '/app/properties/$propertyId/'
    | '/app/tenants/$tenantId/'
    | '/app/utilities/$serviceId/'
    | '/app/contracts/$contractId/amendments/new'
    | '/app/fiscal/declarations/$declarationId/submission'
    | '/app/properties/$propertyId/rent/payments'
    | '/app/utilities/$serviceId/readings/new'
    | '/app/contracts/$contractId/amendments/'
    | '/app/fiscal/declarations/$declarationId/'
    | '/app/properties/$propertyId/rent/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/brand'
    | '/demo'
    | '/forgot-password'
    | '/login'
    | '/mfa'
    | '/register'
    | '/select-client'
    | '/select-contract'
    | '/unsubscribed'
    | '/admin/accounts'
    | '/admin/admin-audit'
    | '/admin/audit'
    | '/admin/email'
    | '/app/action-center'
    | '/app/audit-log'
    | '/app/bilant'
    | '/app/dashboard'
    | '/app/my-building'
    | '/app/notifications'
    | '/app/onboarding'
    | '/app/owner-tenancy'
    | '/portal/building'
    | '/portal/documents'
    | '/portal/meters'
    | '/portal/notifications'
    | '/portal/rent'
    | '/portal/settings'
    | '/admin'
    | '/app'
    | '/portal'
    | '/confirm-become-owner/$token'
    | '/confirm-deletion/$token'
    | '/confirm-email-change/$token'
    | '/invite/$token'
    | '/mfa/enroll'
    | '/preluare-proprietate/$token'
    | '/reset-password/$token'
    | '/set-password/$token'
    | '/verify-email/$token'
    | '/app/buildings/$buildingId'
    | '/app/contracts/new'
    | '/app/documents/$documentId'
    | '/app/equipment/$equipmentId'
    | '/app/equipment/new'
    | '/app/expenses/categories'
    | '/app/expenses/new'
    | '/app/expenses/recurring'
    | '/app/expenses/suppliers'
    | '/app/fiscal/calendar'
    | '/app/fiscal/profile'
    | '/app/health/$propertyId'
    | '/app/properties/new'
    | '/app/rent/payments'
    | '/app/repairs/$ticketId'
    | '/app/repairs/new'
    | '/app/reports/$reportCode'
    | '/app/reports/dosar-fiscal'
    | '/app/settings/gdpr'
    | '/app/settings/members'
    | '/app/settings/notification-rules'
    | '/app/settings/profile'
    | '/app/settings/security'
    | '/app/tenants/new'
    | '/link/incident/$token'
    | '/link/meter/$token'
    | '/portal/incidents/$incidentId'
    | '/app/banking'
    | '/app/buildings'
    | '/app/contracts'
    | '/app/documents'
    | '/app/equipment'
    | '/app/expenses'
    | '/app/fiscal'
    | '/app/health'
    | '/app/insurance'
    | '/app/properties'
    | '/app/rent'
    | '/app/repairs'
    | '/app/reports'
    | '/app/settings'
    | '/app/tenants'
    | '/app/utilities'
    | '/portal/incidents'
    | '/app/contracts/$contractId/c168'
    | '/app/contracts/$contractId/deposit'
    | '/app/contracts/$contractId/documents'
    | '/app/contracts/$contractId/edit'
    | '/app/contracts/$contractId/schedule'
    | '/app/documents/ocr/$documentId'
    | '/app/expenses/$expenseId/edit'
    | '/app/fiscal/c168/$obligationId'
    | '/app/properties/$propertyId/building'
    | '/app/properties/$propertyId/co-owners'
    | '/app/properties/$propertyId/contracts'
    | '/app/properties/$propertyId/costs'
    | '/app/properties/$propertyId/documents'
    | '/app/properties/$propertyId/edit'
    | '/app/properties/$propertyId/equipment'
    | '/app/properties/$propertyId/insurance'
    | '/app/properties/$propertyId/investment'
    | '/app/properties/$propertyId/repairs'
    | '/app/properties/$propertyId/units'
    | '/app/properties/$propertyId/utilities'
    | '/app/tenants/$tenantId/contacts'
    | '/app/tenants/$tenantId/documents'
    | '/app/tenants/$tenantId/edit'
    | '/app/tenants/$tenantId/history'
    | '/app/tenants/$tenantId/homes'
    | '/app/tenants/$tenantId/payments'
    | '/app/tenants/$tenantId/repairs'
    | '/app/contracts/$contractId'
    | '/app/properties/$propertyId'
    | '/app/tenants/$tenantId'
    | '/app/utilities/$serviceId'
    | '/app/contracts/$contractId/amendments/new'
    | '/app/fiscal/declarations/$declarationId/submission'
    | '/app/properties/$propertyId/rent/payments'
    | '/app/utilities/$serviceId/readings/new'
    | '/app/contracts/$contractId/amendments'
    | '/app/fiscal/declarations/$declarationId'
    | '/app/properties/$propertyId/rent'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/app'
    | '/portal'
    | '/_auth'
    | '/brand'
    | '/demo'
    | '/app/settings'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/mfa'
    | '/_auth/register'
    | '/_auth/select-client'
    | '/_auth/select-contract'
    | '/_auth/unsubscribed'
    | '/admin/accounts'
    | '/admin/admin-audit'
    | '/admin/audit'
    | '/admin/email'
    | '/app/action-center'
    | '/app/audit-log'
    | '/app/bilant'
    | '/app/dashboard'
    | '/app/my-building'
    | '/app/notifications'
    | '/app/onboarding'
    | '/app/owner-tenancy'
    | '/portal/building'
    | '/portal/documents'
    | '/portal/meters'
    | '/portal/notifications'
    | '/portal/rent'
    | '/portal/settings'
    | '/admin/'
    | '/app/'
    | '/portal/'
    | '/app/contracts/$contractId'
    | '/app/properties/$propertyId'
    | '/app/tenants/$tenantId'
    | '/_auth/confirm-become-owner/$token'
    | '/_auth/confirm-deletion/$token'
    | '/_auth/confirm-email-change/$token'
    | '/_auth/invite/$token'
    | '/_auth/mfa_/enroll'
    | '/_auth/preluare-proprietate/$token'
    | '/_auth/reset-password/$token'
    | '/_auth/set-password/$token'
    | '/_auth/verify-email/$token'
    | '/app/buildings/$buildingId'
    | '/app/contracts/new'
    | '/app/documents/$documentId'
    | '/app/equipment/$equipmentId'
    | '/app/equipment/new'
    | '/app/expenses/categories'
    | '/app/expenses/new'
    | '/app/expenses/recurring'
    | '/app/expenses/suppliers'
    | '/app/fiscal/calendar'
    | '/app/fiscal/profile'
    | '/app/health/$propertyId'
    | '/app/properties/new'
    | '/app/rent/payments'
    | '/app/repairs/$ticketId'
    | '/app/repairs/new'
    | '/app/reports/$reportCode'
    | '/app/reports/dosar-fiscal'
    | '/app/settings/gdpr'
    | '/app/settings/members'
    | '/app/settings/notification-rules'
    | '/app/settings/profile'
    | '/app/settings/security'
    | '/app/tenants/new'
    | '/link/incident/$token'
    | '/link/meter/$token'
    | '/portal/incidents/$incidentId'
    | '/app/banking/'
    | '/app/buildings/'
    | '/app/contracts/'
    | '/app/documents/'
    | '/app/equipment/'
    | '/app/expenses/'
    | '/app/fiscal/'
    | '/app/health/'
    | '/app/insurance/'
    | '/app/properties/'
    | '/app/rent/'
    | '/app/repairs/'
    | '/app/reports/'
    | '/app/settings/'
    | '/app/tenants/'
    | '/app/utilities/'
    | '/portal/incidents/'
    | '/app/fiscal/declarations/$declarationId'
    | '/app/contracts/$contractId/c168'
    | '/app/contracts/$contractId/deposit'
    | '/app/contracts/$contractId/documents'
    | '/app/contracts/$contractId/edit'
    | '/app/contracts/$contractId/schedule'
    | '/app/documents/ocr/$documentId'
    | '/app/expenses/$expenseId/edit'
    | '/app/fiscal/c168/$obligationId'
    | '/app/properties/$propertyId/building'
    | '/app/properties/$propertyId/co-owners'
    | '/app/properties/$propertyId/contracts'
    | '/app/properties/$propertyId/costs'
    | '/app/properties/$propertyId/documents'
    | '/app/properties/$propertyId/edit'
    | '/app/properties/$propertyId/equipment'
    | '/app/properties/$propertyId/insurance'
    | '/app/properties/$propertyId/investment'
    | '/app/properties/$propertyId/repairs'
    | '/app/properties/$propertyId/units'
    | '/app/properties/$propertyId/utilities'
    | '/app/tenants/$tenantId/contacts'
    | '/app/tenants/$tenantId/documents'
    | '/app/tenants/$tenantId/edit'
    | '/app/tenants/$tenantId/history'
    | '/app/tenants/$tenantId/homes'
    | '/app/tenants/$tenantId/payments'
    | '/app/tenants/$tenantId/repairs'
    | '/app/contracts/$contractId/'
    | '/app/properties/$propertyId/'
    | '/app/tenants/$tenantId/'
    | '/app/utilities/$serviceId/'
    | '/app/contracts/$contractId/amendments/new'
    | '/app/fiscal/declarations/$declarationId/submission'
    | '/app/properties/$propertyId/rent/payments'
    | '/app/utilities/$serviceId/readings/new'
    | '/app/contracts/$contractId/amendments/'
    | '/app/fiscal/declarations/$declarationId/'
    | '/app/properties/$propertyId/rent/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRouteRoute: typeof AdminRouteRouteWithChildren
  AppRouteRoute: typeof AppRouteRouteWithChildren
  PortalRouteRoute: typeof PortalRouteRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  BrandRoute: typeof BrandRoute
  DemoRoute: typeof DemoRoute
  LinkIncidentTokenRoute: typeof LinkIncidentTokenRoute
  LinkMeterTokenRoute: typeof LinkMeterTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/app': {
      id: '/app'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof AppRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/brand': {
      id: '/brand'
      path: '/brand'
      fullPath: '/brand'
      preLoaderRoute: typeof BrandRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/mfa': {
      id: '/_auth/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof AuthMfaRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/register': {
      id: '/_auth/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof AuthRegisterRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/select-client': {
      id: '/_auth/select-client'
      path: '/select-client'
      fullPath: '/select-client'
      preLoaderRoute: typeof AuthSelectClientRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/select-contract': {
      id: '/_auth/select-contract'
      path: '/select-contract'
      fullPath: '/select-contract'
      preLoaderRoute: typeof AuthSelectContractRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/unsubscribed': {
      id: '/_auth/unsubscribed'
      path: '/unsubscribed'
      fullPath: '/unsubscribed'
      preLoaderRoute: typeof AuthUnsubscribedRouteImport
      parentRoute: typeof AuthRoute
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/accounts': {
      id: '/admin/accounts'
      path: '/accounts'
      fullPath: '/admin/accounts'
      preLoaderRoute: typeof AdminAccountsRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/admin-audit': {
      id: '/admin/admin-audit'
      path: '/admin-audit'
      fullPath: '/admin/admin-audit'
      preLoaderRoute: typeof AdminAdminAuditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/audit': {
      id: '/admin/audit'
      path: '/audit'
      fullPath: '/admin/audit'
      preLoaderRoute: typeof AdminAuditRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/admin/email': {
      id: '/admin/email'
      path: '/email'
      fullPath: '/admin/email'
      preLoaderRoute: typeof AdminEmailRouteImport
      parentRoute: typeof AdminRouteRoute
    }
    '/app/': {
      id: '/app/'
      path: '/'
      fullPath: '/app/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/action-center': {
      id: '/app/action-center'
      path: '/action-center'
      fullPath: '/app/action-center'
      preLoaderRoute: typeof AppActionCenterRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/audit-log': {
      id: '/app/audit-log'
      path: '/audit-log'
      fullPath: '/app/audit-log'
      preLoaderRoute: typeof AppAuditLogRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/bilant': {
      id: '/app/bilant'
      path: '/bilant'
      fullPath: '/app/bilant'
      preLoaderRoute: typeof AppBilantRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/dashboard': {
      id: '/app/dashboard'
      path: '/dashboard'
      fullPath: '/app/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/my-building': {
      id: '/app/my-building'
      path: '/my-building'
      fullPath: '/app/my-building'
      preLoaderRoute: typeof AppMyBuildingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/notifications': {
      id: '/app/notifications'
      path: '/notifications'
      fullPath: '/app/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/onboarding': {
      id: '/app/onboarding'
      path: '/onboarding'
      fullPath: '/app/onboarding'
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/owner-tenancy': {
      id: '/app/owner-tenancy'
      path: '/owner-tenancy'
      fullPath: '/app/owner-tenancy'
      preLoaderRoute: typeof AppOwnerTenancyRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings': {
      id: '/app/settings'
      path: '/settings'
      fullPath: '/app/settings'
      preLoaderRoute: typeof AppSettingsRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/portal/': {
      id: '/portal/'
      path: '/'
      fullPath: '/portal/'
      preLoaderRoute: typeof PortalIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/building': {
      id: '/portal/building'
      path: '/building'
      fullPath: '/portal/building'
      preLoaderRoute: typeof PortalBuildingRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/documents': {
      id: '/portal/documents'
      path: '/documents'
      fullPath: '/portal/documents'
      preLoaderRoute: typeof PortalDocumentsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/meters': {
      id: '/portal/meters'
      path: '/meters'
      fullPath: '/portal/meters'
      preLoaderRoute: typeof PortalMetersRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/notifications': {
      id: '/portal/notifications'
      path: '/notifications'
      fullPath: '/portal/notifications'
      preLoaderRoute: typeof PortalNotificationsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/rent': {
      id: '/portal/rent'
      path: '/rent'
      fullPath: '/portal/rent'
      preLoaderRoute: typeof PortalRentRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/settings': {
      id: '/portal/settings'
      path: '/settings'
      fullPath: '/portal/settings'
      preLoaderRoute: typeof PortalSettingsRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/_auth/confirm-become-owner/$token': {
      id: '/_auth/confirm-become-owner/$token'
      path: '/confirm-become-owner/$token'
      fullPath: '/confirm-become-owner/$token'
      preLoaderRoute: typeof AuthConfirmBecomeOwnerTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/confirm-deletion/$token': {
      id: '/_auth/confirm-deletion/$token'
      path: '/confirm-deletion/$token'
      fullPath: '/confirm-deletion/$token'
      preLoaderRoute: typeof AuthConfirmDeletionTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/confirm-email-change/$token': {
      id: '/_auth/confirm-email-change/$token'
      path: '/confirm-email-change/$token'
      fullPath: '/confirm-email-change/$token'
      preLoaderRoute: typeof AuthConfirmEmailChangeTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/invite/$token': {
      id: '/_auth/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof AuthInviteTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/mfa_/enroll': {
      id: '/_auth/mfa_/enroll'
      path: '/mfa/enroll'
      fullPath: '/mfa/enroll'
      preLoaderRoute: typeof AuthMfaEnrollRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/preluare-proprietate/$token': {
      id: '/_auth/preluare-proprietate/$token'
      path: '/preluare-proprietate/$token'
      fullPath: '/preluare-proprietate/$token'
      preLoaderRoute: typeof AuthPreluareProprietateTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password/$token': {
      id: '/_auth/reset-password/$token'
      path: '/reset-password/$token'
      fullPath: '/reset-password/$token'
      preLoaderRoute: typeof AuthResetPasswordTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/set-password/$token': {
      id: '/_auth/set-password/$token'
      path: '/set-password/$token'
      fullPath: '/set-password/$token'
      preLoaderRoute: typeof AuthSetPasswordTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/verify-email/$token': {
      id: '/_auth/verify-email/$token'
      path: '/verify-email/$token'
      fullPath: '/verify-email/$token'
      preLoaderRoute: typeof AuthVerifyEmailTokenRouteImport
      parentRoute: typeof AuthRoute
    }
    '/app/banking/': {
      id: '/app/banking/'
      path: '/banking'
      fullPath: '/app/banking/'
      preLoaderRoute: typeof AppBankingIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/buildings/': {
      id: '/app/buildings/'
      path: '/buildings'
      fullPath: '/app/buildings/'
      preLoaderRoute: typeof AppBuildingsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/buildings/$buildingId': {
      id: '/app/buildings/$buildingId'
      path: '/buildings/$buildingId'
      fullPath: '/app/buildings/$buildingId'
      preLoaderRoute: typeof AppBuildingsBuildingIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/contracts/': {
      id: '/app/contracts/'
      path: '/contracts'
      fullPath: '/app/contracts/'
      preLoaderRoute: typeof AppContractsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/contracts/$contractId': {
      id: '/app/contracts/$contractId'
      path: '/contracts/$contractId'
      fullPath: '/app/contracts/$contractId'
      preLoaderRoute: typeof AppContractsContractIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/contracts/new': {
      id: '/app/contracts/new'
      path: '/contracts/new'
      fullPath: '/app/contracts/new'
      preLoaderRoute: typeof AppContractsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/documents/': {
      id: '/app/documents/'
      path: '/documents'
      fullPath: '/app/documents/'
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/documents/$documentId': {
      id: '/app/documents/$documentId'
      path: '/documents/$documentId'
      fullPath: '/app/documents/$documentId'
      preLoaderRoute: typeof AppDocumentsDocumentIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/equipment/': {
      id: '/app/equipment/'
      path: '/equipment'
      fullPath: '/app/equipment/'
      preLoaderRoute: typeof AppEquipmentIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/equipment/$equipmentId': {
      id: '/app/equipment/$equipmentId'
      path: '/equipment/$equipmentId'
      fullPath: '/app/equipment/$equipmentId'
      preLoaderRoute: typeof AppEquipmentEquipmentIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/equipment/new': {
      id: '/app/equipment/new'
      path: '/equipment/new'
      fullPath: '/app/equipment/new'
      preLoaderRoute: typeof AppEquipmentNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/expenses/': {
      id: '/app/expenses/'
      path: '/expenses'
      fullPath: '/app/expenses/'
      preLoaderRoute: typeof AppExpensesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/expenses/categories': {
      id: '/app/expenses/categories'
      path: '/expenses/categories'
      fullPath: '/app/expenses/categories'
      preLoaderRoute: typeof AppExpensesCategoriesRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/expenses/new': {
      id: '/app/expenses/new'
      path: '/expenses/new'
      fullPath: '/app/expenses/new'
      preLoaderRoute: typeof AppExpensesNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/expenses/recurring': {
      id: '/app/expenses/recurring'
      path: '/expenses/recurring'
      fullPath: '/app/expenses/recurring'
      preLoaderRoute: typeof AppExpensesRecurringRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/expenses/suppliers': {
      id: '/app/expenses/suppliers'
      path: '/expenses/suppliers'
      fullPath: '/app/expenses/suppliers'
      preLoaderRoute: typeof AppExpensesSuppliersRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/fiscal/': {
      id: '/app/fiscal/'
      path: '/fiscal'
      fullPath: '/app/fiscal/'
      preLoaderRoute: typeof AppFiscalIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/fiscal/calendar': {
      id: '/app/fiscal/calendar'
      path: '/fiscal/calendar'
      fullPath: '/app/fiscal/calendar'
      preLoaderRoute: typeof AppFiscalCalendarRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/fiscal/profile': {
      id: '/app/fiscal/profile'
      path: '/fiscal/profile'
      fullPath: '/app/fiscal/profile'
      preLoaderRoute: typeof AppFiscalProfileRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/health/': {
      id: '/app/health/'
      path: '/health'
      fullPath: '/app/health/'
      preLoaderRoute: typeof AppHealthIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/health/$propertyId': {
      id: '/app/health/$propertyId'
      path: '/health/$propertyId'
      fullPath: '/app/health/$propertyId'
      preLoaderRoute: typeof AppHealthPropertyIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/insurance/': {
      id: '/app/insurance/'
      path: '/insurance'
      fullPath: '/app/insurance/'
      preLoaderRoute: typeof AppInsuranceIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/properties/': {
      id: '/app/properties/'
      path: '/properties'
      fullPath: '/app/properties/'
      preLoaderRoute: typeof AppPropertiesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/properties/$propertyId': {
      id: '/app/properties/$propertyId'
      path: '/properties/$propertyId'
      fullPath: '/app/properties/$propertyId'
      preLoaderRoute: typeof AppPropertiesPropertyIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/properties/new': {
      id: '/app/properties/new'
      path: '/properties/new'
      fullPath: '/app/properties/new'
      preLoaderRoute: typeof AppPropertiesNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/rent/': {
      id: '/app/rent/'
      path: '/rent'
      fullPath: '/app/rent/'
      preLoaderRoute: typeof AppRentIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/rent/payments': {
      id: '/app/rent/payments'
      path: '/rent/payments'
      fullPath: '/app/rent/payments'
      preLoaderRoute: typeof AppRentPaymentsRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/repairs/': {
      id: '/app/repairs/'
      path: '/repairs'
      fullPath: '/app/repairs/'
      preLoaderRoute: typeof AppRepairsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/repairs/$ticketId': {
      id: '/app/repairs/$ticketId'
      path: '/repairs/$ticketId'
      fullPath: '/app/repairs/$ticketId'
      preLoaderRoute: typeof AppRepairsTicketIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/repairs/new': {
      id: '/app/repairs/new'
      path: '/repairs/new'
      fullPath: '/app/repairs/new'
      preLoaderRoute: typeof AppRepairsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/reports/': {
      id: '/app/reports/'
      path: '/reports'
      fullPath: '/app/reports/'
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/reports/$reportCode': {
      id: '/app/reports/$reportCode'
      path: '/reports/$reportCode'
      fullPath: '/app/reports/$reportCode'
      preLoaderRoute: typeof AppReportsReportCodeRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/reports/dosar-fiscal': {
      id: '/app/reports/dosar-fiscal'
      path: '/reports/dosar-fiscal'
      fullPath: '/app/reports/dosar-fiscal'
      preLoaderRoute: typeof AppReportsDosarFiscalRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/settings/': {
      id: '/app/settings/'
      path: '/'
      fullPath: '/app/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/gdpr': {
      id: '/app/settings/gdpr'
      path: '/gdpr'
      fullPath: '/app/settings/gdpr'
      preLoaderRoute: typeof AppSettingsGdprRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/members': {
      id: '/app/settings/members'
      path: '/members'
      fullPath: '/app/settings/members'
      preLoaderRoute: typeof AppSettingsMembersRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/notification-rules': {
      id: '/app/settings/notification-rules'
      path: '/notification-rules'
      fullPath: '/app/settings/notification-rules'
      preLoaderRoute: typeof AppSettingsNotificationRulesRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/profile': {
      id: '/app/settings/profile'
      path: '/profile'
      fullPath: '/app/settings/profile'
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/settings/security': {
      id: '/app/settings/security'
      path: '/security'
      fullPath: '/app/settings/security'
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppSettingsRouteRoute
    }
    '/app/tenants/': {
      id: '/app/tenants/'
      path: '/tenants'
      fullPath: '/app/tenants/'
      preLoaderRoute: typeof AppTenantsIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/tenants/$tenantId': {
      id: '/app/tenants/$tenantId'
      path: '/tenants/$tenantId'
      fullPath: '/app/tenants/$tenantId'
      preLoaderRoute: typeof AppTenantsTenantIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/tenants/new': {
      id: '/app/tenants/new'
      path: '/tenants/new'
      fullPath: '/app/tenants/new'
      preLoaderRoute: typeof AppTenantsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/utilities/': {
      id: '/app/utilities/'
      path: '/utilities'
      fullPath: '/app/utilities/'
      preLoaderRoute: typeof AppUtilitiesIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/link/incident/$token': {
      id: '/link/incident/$token'
      path: '/link/incident/$token'
      fullPath: '/link/incident/$token'
      preLoaderRoute: typeof LinkIncidentTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link/meter/$token': {
      id: '/link/meter/$token'
      path: '/link/meter/$token'
      fullPath: '/link/meter/$token'
      preLoaderRoute: typeof LinkMeterTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal/incidents/': {
      id: '/portal/incidents/'
      path: '/incidents'
      fullPath: '/portal/incidents/'
      preLoaderRoute: typeof PortalIncidentsIndexRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/portal/incidents/$incidentId': {
      id: '/portal/incidents/$incidentId'
      path: '/incidents/$incidentId'
      fullPath: '/portal/incidents/$incidentId'
      preLoaderRoute: typeof PortalIncidentsIncidentIdRouteImport
      parentRoute: typeof PortalRouteRoute
    }
    '/app/contracts/$contractId/': {
      id: '/app/contracts/$contractId/'
      path: '/'
      fullPath: '/app/contracts/$contractId/'
      preLoaderRoute: typeof AppContractsContractIdIndexRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/contracts/$contractId/c168': {
      id: '/app/contracts/$contractId/c168'
      path: '/c168'
      fullPath: '/app/contracts/$contractId/c168'
      preLoaderRoute: typeof AppContractsContractIdC168RouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/contracts/$contractId/deposit': {
      id: '/app/contracts/$contractId/deposit'
      path: '/deposit'
      fullPath: '/app/contracts/$contractId/deposit'
      preLoaderRoute: typeof AppContractsContractIdDepositRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/contracts/$contractId/documents': {
      id: '/app/contracts/$contractId/documents'
      path: '/documents'
      fullPath: '/app/contracts/$contractId/documents'
      preLoaderRoute: typeof AppContractsContractIdDocumentsRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/contracts/$contractId/edit': {
      id: '/app/contracts/$contractId/edit'
      path: '/edit'
      fullPath: '/app/contracts/$contractId/edit'
      preLoaderRoute: typeof AppContractsContractIdEditRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/contracts/$contractId/schedule': {
      id: '/app/contracts/$contractId/schedule'
      path: '/schedule'
      fullPath: '/app/contracts/$contractId/schedule'
      preLoaderRoute: typeof AppContractsContractIdScheduleRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/documents/ocr/$documentId': {
      id: '/app/documents/ocr/$documentId'
      path: '/documents/ocr/$documentId'
      fullPath: '/app/documents/ocr/$documentId'
      preLoaderRoute: typeof AppDocumentsOcrDocumentIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/expenses/$expenseId/edit': {
      id: '/app/expenses/$expenseId/edit'
      path: '/expenses/$expenseId/edit'
      fullPath: '/app/expenses/$expenseId/edit'
      preLoaderRoute: typeof AppExpensesExpenseIdEditRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/fiscal/c168/$obligationId': {
      id: '/app/fiscal/c168/$obligationId'
      path: '/fiscal/c168/$obligationId'
      fullPath: '/app/fiscal/c168/$obligationId'
      preLoaderRoute: typeof AppFiscalC168ObligationIdRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/fiscal/declarations/$declarationId': {
      id: '/app/fiscal/declarations/$declarationId'
      path: '/fiscal/declarations/$declarationId'
      fullPath: '/app/fiscal/declarations/$declarationId'
      preLoaderRoute: typeof AppFiscalDeclarationsDeclarationIdRouteRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/properties/$propertyId/': {
      id: '/app/properties/$propertyId/'
      path: '/'
      fullPath: '/app/properties/$propertyId/'
      preLoaderRoute: typeof AppPropertiesPropertyIdIndexRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/building': {
      id: '/app/properties/$propertyId/building'
      path: '/building'
      fullPath: '/app/properties/$propertyId/building'
      preLoaderRoute: typeof AppPropertiesPropertyIdBuildingRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/co-owners': {
      id: '/app/properties/$propertyId/co-owners'
      path: '/co-owners'
      fullPath: '/app/properties/$propertyId/co-owners'
      preLoaderRoute: typeof AppPropertiesPropertyIdCoOwnersRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/contracts': {
      id: '/app/properties/$propertyId/contracts'
      path: '/contracts'
      fullPath: '/app/properties/$propertyId/contracts'
      preLoaderRoute: typeof AppPropertiesPropertyIdContractsRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/costs': {
      id: '/app/properties/$propertyId/costs'
      path: '/costs'
      fullPath: '/app/properties/$propertyId/costs'
      preLoaderRoute: typeof AppPropertiesPropertyIdCostsRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/documents': {
      id: '/app/properties/$propertyId/documents'
      path: '/documents'
      fullPath: '/app/properties/$propertyId/documents'
      preLoaderRoute: typeof AppPropertiesPropertyIdDocumentsRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/edit': {
      id: '/app/properties/$propertyId/edit'
      path: '/edit'
      fullPath: '/app/properties/$propertyId/edit'
      preLoaderRoute: typeof AppPropertiesPropertyIdEditRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/equipment': {
      id: '/app/properties/$propertyId/equipment'
      path: '/equipment'
      fullPath: '/app/properties/$propertyId/equipment'
      preLoaderRoute: typeof AppPropertiesPropertyIdEquipmentRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/insurance': {
      id: '/app/properties/$propertyId/insurance'
      path: '/insurance'
      fullPath: '/app/properties/$propertyId/insurance'
      preLoaderRoute: typeof AppPropertiesPropertyIdInsuranceRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/investment': {
      id: '/app/properties/$propertyId/investment'
      path: '/investment'
      fullPath: '/app/properties/$propertyId/investment'
      preLoaderRoute: typeof AppPropertiesPropertyIdInvestmentRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/repairs': {
      id: '/app/properties/$propertyId/repairs'
      path: '/repairs'
      fullPath: '/app/properties/$propertyId/repairs'
      preLoaderRoute: typeof AppPropertiesPropertyIdRepairsRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/units': {
      id: '/app/properties/$propertyId/units'
      path: '/units'
      fullPath: '/app/properties/$propertyId/units'
      preLoaderRoute: typeof AppPropertiesPropertyIdUnitsRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/utilities': {
      id: '/app/properties/$propertyId/utilities'
      path: '/utilities'
      fullPath: '/app/properties/$propertyId/utilities'
      preLoaderRoute: typeof AppPropertiesPropertyIdUtilitiesRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/tenants/$tenantId/': {
      id: '/app/tenants/$tenantId/'
      path: '/'
      fullPath: '/app/tenants/$tenantId/'
      preLoaderRoute: typeof AppTenantsTenantIdIndexRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/contacts': {
      id: '/app/tenants/$tenantId/contacts'
      path: '/contacts'
      fullPath: '/app/tenants/$tenantId/contacts'
      preLoaderRoute: typeof AppTenantsTenantIdContactsRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/documents': {
      id: '/app/tenants/$tenantId/documents'
      path: '/documents'
      fullPath: '/app/tenants/$tenantId/documents'
      preLoaderRoute: typeof AppTenantsTenantIdDocumentsRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/edit': {
      id: '/app/tenants/$tenantId/edit'
      path: '/edit'
      fullPath: '/app/tenants/$tenantId/edit'
      preLoaderRoute: typeof AppTenantsTenantIdEditRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/history': {
      id: '/app/tenants/$tenantId/history'
      path: '/history'
      fullPath: '/app/tenants/$tenantId/history'
      preLoaderRoute: typeof AppTenantsTenantIdHistoryRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/homes': {
      id: '/app/tenants/$tenantId/homes'
      path: '/homes'
      fullPath: '/app/tenants/$tenantId/homes'
      preLoaderRoute: typeof AppTenantsTenantIdHomesRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/payments': {
      id: '/app/tenants/$tenantId/payments'
      path: '/payments'
      fullPath: '/app/tenants/$tenantId/payments'
      preLoaderRoute: typeof AppTenantsTenantIdPaymentsRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/tenants/$tenantId/repairs': {
      id: '/app/tenants/$tenantId/repairs'
      path: '/repairs'
      fullPath: '/app/tenants/$tenantId/repairs'
      preLoaderRoute: typeof AppTenantsTenantIdRepairsRouteImport
      parentRoute: typeof AppTenantsTenantIdRouteRoute
    }
    '/app/utilities/$serviceId/': {
      id: '/app/utilities/$serviceId/'
      path: '/utilities/$serviceId'
      fullPath: '/app/utilities/$serviceId/'
      preLoaderRoute: typeof AppUtilitiesServiceIdIndexRouteImport
      parentRoute: typeof AppRouteRoute
    }
    '/app/contracts/$contractId/amendments/': {
      id: '/app/contracts/$contractId/amendments/'
      path: '/amendments'
      fullPath: '/app/contracts/$contractId/amendments/'
      preLoaderRoute: typeof AppContractsContractIdAmendmentsIndexRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/contracts/$contractId/amendments/new': {
      id: '/app/contracts/$contractId/amendments/new'
      path: '/amendments/new'
      fullPath: '/app/contracts/$contractId/amendments/new'
      preLoaderRoute: typeof AppContractsContractIdAmendmentsNewRouteImport
      parentRoute: typeof AppContractsContractIdRouteRoute
    }
    '/app/fiscal/declarations/$declarationId/': {
      id: '/app/fiscal/declarations/$declarationId/'
      path: '/'
      fullPath: '/app/fiscal/declarations/$declarationId/'
      preLoaderRoute: typeof AppFiscalDeclarationsDeclarationIdIndexRouteImport
      parentRoute: typeof AppFiscalDeclarationsDeclarationIdRouteRoute
    }
    '/app/fiscal/declarations/$declarationId/submission': {
      id: '/app/fiscal/declarations/$declarationId/submission'
      path: '/submission'
      fullPath: '/app/fiscal/declarations/$declarationId/submission'
      preLoaderRoute: typeof AppFiscalDeclarationsDeclarationIdSubmissionRouteImport
      parentRoute: typeof AppFiscalDeclarationsDeclarationIdRouteRoute
    }
    '/app/properties/$propertyId/rent/': {
      id: '/app/properties/$propertyId/rent/'
      path: '/rent'
      fullPath: '/app/properties/$propertyId/rent/'
      preLoaderRoute: typeof AppPropertiesPropertyIdRentIndexRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/properties/$propertyId/rent/payments': {
      id: '/app/properties/$propertyId/rent/payments'
      path: '/rent/payments'
      fullPath: '/app/properties/$propertyId/rent/payments'
      preLoaderRoute: typeof AppPropertiesPropertyIdRentPaymentsRouteImport
      parentRoute: typeof AppPropertiesPropertyIdRouteRoute
    }
    '/app/utilities/$serviceId/readings/new': {
      id: '/app/utilities/$serviceId/readings/new'
      path: '/utilities/$serviceId/readings/new'
      fullPath: '/app/utilities/$serviceId/readings/new'
      preLoaderRoute: typeof AppUtilitiesServiceIdReadingsNewRouteImport
      parentRoute: typeof AppRouteRoute
    }
  }
}

interface AdminRouteRouteChildren {
  AdminAccountsRoute: typeof AdminAccountsRoute
  AdminAdminAuditRoute: typeof AdminAdminAuditRoute
  AdminAuditRoute: typeof AdminAuditRoute
  AdminEmailRoute: typeof AdminEmailRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteRouteChildren: AdminRouteRouteChildren = {
  AdminAccountsRoute: AdminAccountsRoute,
  AdminAdminAuditRoute: AdminAdminAuditRoute,
  AdminAuditRoute: AdminAuditRoute,
  AdminEmailRoute: AdminEmailRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteRouteWithChildren = AdminRouteRoute._addFileChildren(
  AdminRouteRouteChildren,
)

interface AppSettingsRouteRouteChildren {
  AppSettingsGdprRoute: typeof AppSettingsGdprRoute
  AppSettingsMembersRoute: typeof AppSettingsMembersRoute
  AppSettingsNotificationRulesRoute: typeof AppSettingsNotificationRulesRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppSettingsRouteRouteChildren: AppSettingsRouteRouteChildren = {
  AppSettingsGdprRoute: AppSettingsGdprRoute,
  AppSettingsMembersRoute: AppSettingsMembersRoute,
  AppSettingsNotificationRulesRoute: AppSettingsNotificationRulesRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppSettingsRouteRouteWithChildren =
  AppSettingsRouteRoute._addFileChildren(AppSettingsRouteRouteChildren)

interface AppContractsContractIdRouteRouteChildren {
  AppContractsContractIdC168Route: typeof AppContractsContractIdC168Route
  AppContractsContractIdDepositRoute: typeof AppContractsContractIdDepositRoute
  AppContractsContractIdDocumentsRoute: typeof AppContractsContractIdDocumentsRoute
  AppContractsContractIdEditRoute: typeof AppContractsContractIdEditRoute
  AppContractsContractIdScheduleRoute: typeof AppContractsContractIdScheduleRoute
  AppContractsContractIdIndexRoute: typeof AppContractsContractIdIndexRoute
  AppContractsContractIdAmendmentsNewRoute: typeof AppContractsContractIdAmendmentsNewRoute
  AppContractsContractIdAmendmentsIndexRoute: typeof AppContractsContractIdAmendmentsIndexRoute
}

const AppContractsContractIdRouteRouteChildren: AppContractsContractIdRouteRouteChildren =
  {
    AppContractsContractIdC168Route: AppContractsContractIdC168Route,
    AppContractsContractIdDepositRoute: AppContractsContractIdDepositRoute,
    AppContractsContractIdDocumentsRoute: AppContractsContractIdDocumentsRoute,
    AppContractsContractIdEditRoute: AppContractsContractIdEditRoute,
    AppContractsContractIdScheduleRoute: AppContractsContractIdScheduleRoute,
    AppContractsContractIdIndexRoute: AppContractsContractIdIndexRoute,
    AppContractsContractIdAmendmentsNewRoute:
      AppContractsContractIdAmendmentsNewRoute,
    AppContractsContractIdAmendmentsIndexRoute:
      AppContractsContractIdAmendmentsIndexRoute,
  }

const AppContractsContractIdRouteRouteWithChildren =
  AppContractsContractIdRouteRoute._addFileChildren(
    AppContractsContractIdRouteRouteChildren,
  )

interface AppPropertiesPropertyIdRouteRouteChildren {
  AppPropertiesPropertyIdBuildingRoute: typeof AppPropertiesPropertyIdBuildingRoute
  AppPropertiesPropertyIdCoOwnersRoute: typeof AppPropertiesPropertyIdCoOwnersRoute
  AppPropertiesPropertyIdContractsRoute: typeof AppPropertiesPropertyIdContractsRoute
  AppPropertiesPropertyIdCostsRoute: typeof AppPropertiesPropertyIdCostsRoute
  AppPropertiesPropertyIdDocumentsRoute: typeof AppPropertiesPropertyIdDocumentsRoute
  AppPropertiesPropertyIdEditRoute: typeof AppPropertiesPropertyIdEditRoute
  AppPropertiesPropertyIdEquipmentRoute: typeof AppPropertiesPropertyIdEquipmentRoute
  AppPropertiesPropertyIdInsuranceRoute: typeof AppPropertiesPropertyIdInsuranceRoute
  AppPropertiesPropertyIdInvestmentRoute: typeof AppPropertiesPropertyIdInvestmentRoute
  AppPropertiesPropertyIdRepairsRoute: typeof AppPropertiesPropertyIdRepairsRoute
  AppPropertiesPropertyIdUnitsRoute: typeof AppPropertiesPropertyIdUnitsRoute
  AppPropertiesPropertyIdUtilitiesRoute: typeof AppPropertiesPropertyIdUtilitiesRoute
  AppPropertiesPropertyIdIndexRoute: typeof AppPropertiesPropertyIdIndexRoute
  AppPropertiesPropertyIdRentPaymentsRoute: typeof AppPropertiesPropertyIdRentPaymentsRoute
  AppPropertiesPropertyIdRentIndexRoute: typeof AppPropertiesPropertyIdRentIndexRoute
}

const AppPropertiesPropertyIdRouteRouteChildren: AppPropertiesPropertyIdRouteRouteChildren =
  {
    AppPropertiesPropertyIdBuildingRoute: AppPropertiesPropertyIdBuildingRoute,
    AppPropertiesPropertyIdCoOwnersRoute: AppPropertiesPropertyIdCoOwnersRoute,
    AppPropertiesPropertyIdContractsRoute:
      AppPropertiesPropertyIdContractsRoute,
    AppPropertiesPropertyIdCostsRoute: AppPropertiesPropertyIdCostsRoute,
    AppPropertiesPropertyIdDocumentsRoute:
      AppPropertiesPropertyIdDocumentsRoute,
    AppPropertiesPropertyIdEditRoute: AppPropertiesPropertyIdEditRoute,
    AppPropertiesPropertyIdEquipmentRoute:
      AppPropertiesPropertyIdEquipmentRoute,
    AppPropertiesPropertyIdInsuranceRoute:
      AppPropertiesPropertyIdInsuranceRoute,
    AppPropertiesPropertyIdInvestmentRoute:
      AppPropertiesPropertyIdInvestmentRoute,
    AppPropertiesPropertyIdRepairsRoute: AppPropertiesPropertyIdRepairsRoute,
    AppPropertiesPropertyIdUnitsRoute: AppPropertiesPropertyIdUnitsRoute,
    AppPropertiesPropertyIdUtilitiesRoute:
      AppPropertiesPropertyIdUtilitiesRoute,
    AppPropertiesPropertyIdIndexRoute: AppPropertiesPropertyIdIndexRoute,
    AppPropertiesPropertyIdRentPaymentsRoute:
      AppPropertiesPropertyIdRentPaymentsRoute,
    AppPropertiesPropertyIdRentIndexRoute:
      AppPropertiesPropertyIdRentIndexRoute,
  }

const AppPropertiesPropertyIdRouteRouteWithChildren =
  AppPropertiesPropertyIdRouteRoute._addFileChildren(
    AppPropertiesPropertyIdRouteRouteChildren,
  )

interface AppTenantsTenantIdRouteRouteChildren {
  AppTenantsTenantIdContactsRoute: typeof AppTenantsTenantIdContactsRoute
  AppTenantsTenantIdDocumentsRoute: typeof AppTenantsTenantIdDocumentsRoute
  AppTenantsTenantIdEditRoute: typeof AppTenantsTenantIdEditRoute
  AppTenantsTenantIdHistoryRoute: typeof AppTenantsTenantIdHistoryRoute
  AppTenantsTenantIdHomesRoute: typeof AppTenantsTenantIdHomesRoute
  AppTenantsTenantIdPaymentsRoute: typeof AppTenantsTenantIdPaymentsRoute
  AppTenantsTenantIdRepairsRoute: typeof AppTenantsTenantIdRepairsRoute
  AppTenantsTenantIdIndexRoute: typeof AppTenantsTenantIdIndexRoute
}

const AppTenantsTenantIdRouteRouteChildren: AppTenantsTenantIdRouteRouteChildren =
  {
    AppTenantsTenantIdContactsRoute: AppTenantsTenantIdContactsRoute,
    AppTenantsTenantIdDocumentsRoute: AppTenantsTenantIdDocumentsRoute,
    AppTenantsTenantIdEditRoute: AppTenantsTenantIdEditRoute,
    AppTenantsTenantIdHistoryRoute: AppTenantsTenantIdHistoryRoute,
    AppTenantsTenantIdHomesRoute: AppTenantsTenantIdHomesRoute,
    AppTenantsTenantIdPaymentsRoute: AppTenantsTenantIdPaymentsRoute,
    AppTenantsTenantIdRepairsRoute: AppTenantsTenantIdRepairsRoute,
    AppTenantsTenantIdIndexRoute: AppTenantsTenantIdIndexRoute,
  }

const AppTenantsTenantIdRouteRouteWithChildren =
  AppTenantsTenantIdRouteRoute._addFileChildren(
    AppTenantsTenantIdRouteRouteChildren,
  )

interface AppFiscalDeclarationsDeclarationIdRouteRouteChildren {
  AppFiscalDeclarationsDeclarationIdSubmissionRoute: typeof AppFiscalDeclarationsDeclarationIdSubmissionRoute
  AppFiscalDeclarationsDeclarationIdIndexRoute: typeof AppFiscalDeclarationsDeclarationIdIndexRoute
}

const AppFiscalDeclarationsDeclarationIdRouteRouteChildren: AppFiscalDeclarationsDeclarationIdRouteRouteChildren =
  {
    AppFiscalDeclarationsDeclarationIdSubmissionRoute:
      AppFiscalDeclarationsDeclarationIdSubmissionRoute,
    AppFiscalDeclarationsDeclarationIdIndexRoute:
      AppFiscalDeclarationsDeclarationIdIndexRoute,
  }

const AppFiscalDeclarationsDeclarationIdRouteRouteWithChildren =
  AppFiscalDeclarationsDeclarationIdRouteRoute._addFileChildren(
    AppFiscalDeclarationsDeclarationIdRouteRouteChildren,
  )

interface AppRouteRouteChildren {
  AppSettingsRouteRoute: typeof AppSettingsRouteRouteWithChildren
  AppActionCenterRoute: typeof AppActionCenterRoute
  AppAuditLogRoute: typeof AppAuditLogRoute
  AppBilantRoute: typeof AppBilantRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppMyBuildingRoute: typeof AppMyBuildingRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppOwnerTenancyRoute: typeof AppOwnerTenancyRoute
  AppIndexRoute: typeof AppIndexRoute
  AppContractsContractIdRouteRoute: typeof AppContractsContractIdRouteRouteWithChildren
  AppPropertiesPropertyIdRouteRoute: typeof AppPropertiesPropertyIdRouteRouteWithChildren
  AppTenantsTenantIdRouteRoute: typeof AppTenantsTenantIdRouteRouteWithChildren
  AppBuildingsBuildingIdRoute: typeof AppBuildingsBuildingIdRoute
  AppContractsNewRoute: typeof AppContractsNewRoute
  AppDocumentsDocumentIdRoute: typeof AppDocumentsDocumentIdRoute
  AppEquipmentEquipmentIdRoute: typeof AppEquipmentEquipmentIdRoute
  AppEquipmentNewRoute: typeof AppEquipmentNewRoute
  AppExpensesCategoriesRoute: typeof AppExpensesCategoriesRoute
  AppExpensesNewRoute: typeof AppExpensesNewRoute
  AppExpensesRecurringRoute: typeof AppExpensesRecurringRoute
  AppExpensesSuppliersRoute: typeof AppExpensesSuppliersRoute
  AppFiscalCalendarRoute: typeof AppFiscalCalendarRoute
  AppFiscalProfileRoute: typeof AppFiscalProfileRoute
  AppHealthPropertyIdRoute: typeof AppHealthPropertyIdRoute
  AppPropertiesNewRoute: typeof AppPropertiesNewRoute
  AppRentPaymentsRoute: typeof AppRentPaymentsRoute
  AppRepairsTicketIdRoute: typeof AppRepairsTicketIdRoute
  AppRepairsNewRoute: typeof AppRepairsNewRoute
  AppReportsReportCodeRoute: typeof AppReportsReportCodeRoute
  AppReportsDosarFiscalRoute: typeof AppReportsDosarFiscalRoute
  AppTenantsNewRoute: typeof AppTenantsNewRoute
  AppBankingIndexRoute: typeof AppBankingIndexRoute
  AppBuildingsIndexRoute: typeof AppBuildingsIndexRoute
  AppContractsIndexRoute: typeof AppContractsIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppEquipmentIndexRoute: typeof AppEquipmentIndexRoute
  AppExpensesIndexRoute: typeof AppExpensesIndexRoute
  AppFiscalIndexRoute: typeof AppFiscalIndexRoute
  AppHealthIndexRoute: typeof AppHealthIndexRoute
  AppInsuranceIndexRoute: typeof AppInsuranceIndexRoute
  AppPropertiesIndexRoute: typeof AppPropertiesIndexRoute
  AppRentIndexRoute: typeof AppRentIndexRoute
  AppRepairsIndexRoute: typeof AppRepairsIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppTenantsIndexRoute: typeof AppTenantsIndexRoute
  AppUtilitiesIndexRoute: typeof AppUtilitiesIndexRoute
  AppFiscalDeclarationsDeclarationIdRouteRoute: typeof AppFiscalDeclarationsDeclarationIdRouteRouteWithChildren
  AppDocumentsOcrDocumentIdRoute: typeof AppDocumentsOcrDocumentIdRoute
  AppExpensesExpenseIdEditRoute: typeof AppExpensesExpenseIdEditRoute
  AppFiscalC168ObligationIdRoute: typeof AppFiscalC168ObligationIdRoute
  AppUtilitiesServiceIdIndexRoute: typeof AppUtilitiesServiceIdIndexRoute
  AppUtilitiesServiceIdReadingsNewRoute: typeof AppUtilitiesServiceIdReadingsNewRoute
}

const AppRouteRouteChildren: AppRouteRouteChildren = {
  AppSettingsRouteRoute: AppSettingsRouteRouteWithChildren,
  AppActionCenterRoute: AppActionCenterRoute,
  AppAuditLogRoute: AppAuditLogRoute,
  AppBilantRoute: AppBilantRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppMyBuildingRoute: AppMyBuildingRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppOwnerTenancyRoute: AppOwnerTenancyRoute,
  AppIndexRoute: AppIndexRoute,
  AppContractsContractIdRouteRoute:
    AppContractsContractIdRouteRouteWithChildren,
  AppPropertiesPropertyIdRouteRoute:
    AppPropertiesPropertyIdRouteRouteWithChildren,
  AppTenantsTenantIdRouteRoute: AppTenantsTenantIdRouteRouteWithChildren,
  AppBuildingsBuildingIdRoute: AppBuildingsBuildingIdRoute,
  AppContractsNewRoute: AppContractsNewRoute,
  AppDocumentsDocumentIdRoute: AppDocumentsDocumentIdRoute,
  AppEquipmentEquipmentIdRoute: AppEquipmentEquipmentIdRoute,
  AppEquipmentNewRoute: AppEquipmentNewRoute,
  AppExpensesCategoriesRoute: AppExpensesCategoriesRoute,
  AppExpensesNewRoute: AppExpensesNewRoute,
  AppExpensesRecurringRoute: AppExpensesRecurringRoute,
  AppExpensesSuppliersRoute: AppExpensesSuppliersRoute,
  AppFiscalCalendarRoute: AppFiscalCalendarRoute,
  AppFiscalProfileRoute: AppFiscalProfileRoute,
  AppHealthPropertyIdRoute: AppHealthPropertyIdRoute,
  AppPropertiesNewRoute: AppPropertiesNewRoute,
  AppRentPaymentsRoute: AppRentPaymentsRoute,
  AppRepairsTicketIdRoute: AppRepairsTicketIdRoute,
  AppRepairsNewRoute: AppRepairsNewRoute,
  AppReportsReportCodeRoute: AppReportsReportCodeRoute,
  AppReportsDosarFiscalRoute: AppReportsDosarFiscalRoute,
  AppTenantsNewRoute: AppTenantsNewRoute,
  AppBankingIndexRoute: AppBankingIndexRoute,
  AppBuildingsIndexRoute: AppBuildingsIndexRoute,
  AppContractsIndexRoute: AppContractsIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppEquipmentIndexRoute: AppEquipmentIndexRoute,
  AppExpensesIndexRoute: AppExpensesIndexRoute,
  AppFiscalIndexRoute: AppFiscalIndexRoute,
  AppHealthIndexRoute: AppHealthIndexRoute,
  AppInsuranceIndexRoute: AppInsuranceIndexRoute,
  AppPropertiesIndexRoute: AppPropertiesIndexRoute,
  AppRentIndexRoute: AppRentIndexRoute,
  AppRepairsIndexRoute: AppRepairsIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppTenantsIndexRoute: AppTenantsIndexRoute,
  AppUtilitiesIndexRoute: AppUtilitiesIndexRoute,
  AppFiscalDeclarationsDeclarationIdRouteRoute:
    AppFiscalDeclarationsDeclarationIdRouteRouteWithChildren,
  AppDocumentsOcrDocumentIdRoute: AppDocumentsOcrDocumentIdRoute,
  AppExpensesExpenseIdEditRoute: AppExpensesExpenseIdEditRoute,
  AppFiscalC168ObligationIdRoute: AppFiscalC168ObligationIdRoute,
  AppUtilitiesServiceIdIndexRoute: AppUtilitiesServiceIdIndexRoute,
  AppUtilitiesServiceIdReadingsNewRoute: AppUtilitiesServiceIdReadingsNewRoute,
}

const AppRouteRouteWithChildren = AppRouteRoute._addFileChildren(
  AppRouteRouteChildren,
)

interface PortalRouteRouteChildren {
  PortalBuildingRoute: typeof PortalBuildingRoute
  PortalDocumentsRoute: typeof PortalDocumentsRoute
  PortalMetersRoute: typeof PortalMetersRoute
  PortalNotificationsRoute: typeof PortalNotificationsRoute
  PortalRentRoute: typeof PortalRentRoute
  PortalSettingsRoute: typeof PortalSettingsRoute
  PortalIndexRoute: typeof PortalIndexRoute
  PortalIncidentsIncidentIdRoute: typeof PortalIncidentsIncidentIdRoute
  PortalIncidentsIndexRoute: typeof PortalIncidentsIndexRoute
}

const PortalRouteRouteChildren: PortalRouteRouteChildren = {
  PortalBuildingRoute: PortalBuildingRoute,
  PortalDocumentsRoute: PortalDocumentsRoute,
  PortalMetersRoute: PortalMetersRoute,
  PortalNotificationsRoute: PortalNotificationsRoute,
  PortalRentRoute: PortalRentRoute,
  PortalSettingsRoute: PortalSettingsRoute,
  PortalIndexRoute: PortalIndexRoute,
  PortalIncidentsIncidentIdRoute: PortalIncidentsIncidentIdRoute,
  PortalIncidentsIndexRoute: PortalIncidentsIndexRoute,
}

const PortalRouteRouteWithChildren = PortalRouteRoute._addFileChildren(
  PortalRouteRouteChildren,
)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthMfaRoute: typeof AuthMfaRoute
  AuthRegisterRoute: typeof AuthRegisterRoute
  AuthSelectClientRoute: typeof AuthSelectClientRoute
  AuthSelectContractRoute: typeof AuthSelectContractRoute
  AuthUnsubscribedRoute: typeof AuthUnsubscribedRoute
  AuthConfirmBecomeOwnerTokenRoute: typeof AuthConfirmBecomeOwnerTokenRoute
  AuthConfirmDeletionTokenRoute: typeof AuthConfirmDeletionTokenRoute
  AuthConfirmEmailChangeTokenRoute: typeof AuthConfirmEmailChangeTokenRoute
  AuthInviteTokenRoute: typeof AuthInviteTokenRoute
  AuthMfaEnrollRoute: typeof AuthMfaEnrollRoute
  AuthPreluareProprietateTokenRoute: typeof AuthPreluareProprietateTokenRoute
  AuthResetPasswordTokenRoute: typeof AuthResetPasswordTokenRoute
  AuthSetPasswordTokenRoute: typeof AuthSetPasswordTokenRoute
  AuthVerifyEmailTokenRoute: typeof AuthVerifyEmailTokenRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthMfaRoute: AuthMfaRoute,
  AuthRegisterRoute: AuthRegisterRoute,
  AuthSelectClientRoute: AuthSelectClientRoute,
  AuthSelectContractRoute: AuthSelectContractRoute,
  AuthUnsubscribedRoute: AuthUnsubscribedRoute,
  AuthConfirmBecomeOwnerTokenRoute: AuthConfirmBecomeOwnerTokenRoute,
  AuthConfirmDeletionTokenRoute: AuthConfirmDeletionTokenRoute,
  AuthConfirmEmailChangeTokenRoute: AuthConfirmEmailChangeTokenRoute,
  AuthInviteTokenRoute: AuthInviteTokenRoute,
  AuthMfaEnrollRoute: AuthMfaEnrollRoute,
  AuthPreluareProprietateTokenRoute: AuthPreluareProprietateTokenRoute,
  AuthResetPasswordTokenRoute: AuthResetPasswordTokenRoute,
  AuthSetPasswordTokenRoute: AuthSetPasswordTokenRoute,
  AuthVerifyEmailTokenRoute: AuthVerifyEmailTokenRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRouteRoute: AdminRouteRouteWithChildren,
  AppRouteRoute: AppRouteRouteWithChildren,
  PortalRouteRoute: PortalRouteRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  BrandRoute: BrandRoute,
  DemoRoute: DemoRoute,
  LinkIncidentTokenRoute: LinkIncidentTokenRoute,
  LinkMeterTokenRoute: LinkMeterTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
